export default {
  'pages.accounting.salaryManagement.settlement.proration': '日割精算',
  'pages.accounting.salaryManagement.settlement.prorationHelp':
    '基本給のみ{days}/{total}日で精算：{amount}。会社保険負担は通常月額のままです。',
  'pages.accounting.salaryManagement.settlement.compensation': '個別補償',
  'pages.accounting.salaryManagement.settlement.compensationHelp':
    '通常コストに加えて当月に補償{amount}を1回計上します。他月の給与や実支払記録は生成しません。',
  'pages.accounting.salaryManagement.settlement.monthlyBase': '元の月額基本給：{amount}',
  'pages.accounting.salaryManagement.settlement.reviewHelp':
    '個別精算の前提と入退社日が異なります。給与とコストを確認してください。',
  'pages.development.frontendStage': '段階1：フロントエンド学習',
  'pages.development.backendStage': '段階2：バックエンド学習',
  'pages.development.backendProgressStage': '段階2：バックエンド学習（SQL・Java）',
  'pages.development.displayName': '表示名',
  'pages.development.sourceName': '元の名称（動画・データ参照用）',
  'pages.development.stageFilter': '学習段階',
  'pages.development.topicFilter': '学習テーマ',
  'pages.accountManagement.delete.departureRequired':
    '契約社員・正社員は、停用前に社員情報で退社日を入力してください。',
  'pages.accountManagement.restore': '再開',
  'pages.accountManagement.restore.confirmTitle': 'アカウントを再開しますか？',
  'pages.accountManagement.restore.confirmDescription':
    '「{accountName}」のログインと保持済みロール・関連情報を再有効化します。退社情報は変更しません。過去に削除されたロールは個別に再設定してください。',
  'pages.accountManagement.restore.done':
    'アカウントを再開し、保持済みロール・関連情報を再有効化しました。過去に削除されたロールは再設定してください。',
  'pages.accountManagement.restore.failed': 'アカウントの再開に失敗しました。',
  'pages.accounting.salaryManagement.historicalMonth': '過去年月は参照のみです。',
  'pages.accounting.salaryManagement.contractType.management': '正社員・管理',
  'pages.accounting.salaryManagement.cost.fixedHelp':
    '案件収入が0円のため、経営管理用コストは10万円固定です。実給与・保険明細は変更しません。',
  'pages.accounting.dashboard.fixedCost.note':
    '案件収入0円の一般社員は月額10万円の経営コストを適用します。管理社員と承認済み社内社員は対象外です。個別の日割・補償は別表示し、給与・保険明細の合計と異なる場合があります。',
  'pages.accounting.dashboard.warning.payrollDetail':
    '給与・保険明細に未確認の資料があります。固定コスト適用者の利益は計算できます。',
  'pages.layouts.userLayout.title': 'コードだけじゃない、未来をデバッグしている',
  'pages.login.accountLogin.tab': 'アカウントログイン',
  'pages.login.accountLogin.errorMessage': 'ユーザー名/パスワードが正しくありません',
  'pages.login.failure': 'ログインに失敗したら、もう一度試してください!',
  'pages.login.success': 'ログイン成功!',
  'pages.login.accountName.placeholder': 'ユーザー名：',
  'pages.login.accountName.required': 'ユーザー名を入力してください！',
  'pages.login.password.placeholder': 'パスワード：',
  'pages.login.password.required': 'パスワードを入力してください！',
  'pages.login.phoneLogin.tab': '電話ログイン',
  'pages.login.phoneLogin.errorMessage': '検証コードエラー',
  'pages.login.phoneNumber.placeholder': '電話番号',
  'pages.login.phoneNumber.required': '電話番号を入力してください！',
  'pages.login.phoneNumber.invalid': '電話番号が無効です！',
  'pages.login.captcha.placeholder': '確認コード',
  'pages.login.captcha.required': '確認コードを入力してください！',
  'pages.login.phoneLogin.getVerificationCode': '確認コードを取得',
  'pages.getCaptchaSecondText': '秒',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'パスワードをお忘れですか？',
  'pages.login.submit': 'ログイン',
  'pages.login.loginWith': 'その他のログイン方法：',
  'pages.login.registerAccount': 'アカウント登録',
  'pages.welcome.link': 'ホーム',
  'pages.welcome.alertMessage': 'より高速で強力な頑丈なコンポーネントがリリースされました。',
  'pages.404.subTitle': '申し訳ありませんが、アクセスしたページは存在しません。',
  'pages.404.buttonText': 'ホームに戻る',
  'pages.admin.subPage.title': 'このページは管理者のみが表示できます',
  'pages.admin.subPage.alertMessage':
    'Umi uiがリリースされました。npm run uiを使用して体験してください。',
  'pages.searchTable.createForm.newRule': '新しいルール',
  'pages.searchTable.updateForm.ruleConfig': 'ルール構成',
  'pages.searchTable.updateForm.basicConfig': '基本情報',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'ルール名',
  'pages.searchTable.updateForm.ruleName.nameRules': 'ルール名を入力してください！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'ルールの説明',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '5文字以上入力してください',
  'pages.searchTable.updateForm.ruleDesc.descRules': '5文字以上のルールの説明を入力してください！',
  'pages.searchTable.updateForm.ruleProps.title': 'プロパティの構成',
  'pages.searchTable.updateForm.object': '監視対象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'ルールテンプレート',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'ルールタイプ',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'スケジュール期間の設定',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '開始時間を選択してください！',
  'pages.searchTable.titleDesc': '説明',
  'pages.searchTable.ruleName': 'ルール名が必要です',
  'pages.searchTable.titleCallNo': 'サービスコール数',
  'pages.searchTable.titleStatus': 'ステータス',
  'pages.searchTable.nameStatus.default': 'デフォルト',
  'pages.searchTable.nameStatus.running': '起動中',
  'pages.searchTable.nameStatus.online': 'オンライン',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '最終スケジュール',
  'pages.searchTable.exception': '例外の理由を入力してください！',
  'pages.searchTable.titleOption': 'オプション',
  'pages.searchTable.config': '構成',
  'pages.searchTable.subscribeAlert': 'アラートを購読する',
  'pages.searchTable.title': 'お問い合わせフォーム',
  'pages.searchTable.new': '新しい',
  'pages.searchTable.chosen': '選んだ項目',
  'pages.searchTable.item': '項目',
  'pages.searchTable.totalServiceCalls': 'サービスコールの総数',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': 'バッチ削除',
  'pages.searchTable.batchApproval': 'バッチ承認',

  // アカウント管理画面
  'pages.roleManagement.selectedDelete': 'ロール名',
  'pages.roleManagement.roleDescription': 'ロール説明',
  'pages.roleManagement.operation': '操作',
  'pages.roleManagement.roleList': 'ロール一覧',
  'pages.roleManagement.createRole': 'ロール作成',
  'pages.roleManagement.updateRole': 'ロール更新',
  'pages.roleManagement.ruleNameIsRequired': 'ロール名が必要です',

  // 画面権限管理
  'pages.pageAuthManagement.pageId': '画面ID',
  'pages.pageAuthManagement.pageName': '画面名',
  'pages.pageAuthManagement.description': '画面説明',
  'pages.pageAuthManagement.operation': '操作',
  'pages.pageAuthManagement.auth': '権限編集',
  'pages.pageAuthManagement.update': '設定',
  'pages.pageAuthManagement.serachList': '検索結果',
  'pages.pageAuthManagement.searchList': '検索結果',
  'pages.pageAuthManagement.title': '画面権限管理',
  'pages.pageAuthManagement.search.button': '検索',
  'pages.pageAuthManagement.search.placeholder': '画面ID / 画面名 / 画面説明で検索',
  'pages.pageAuthManagement.search.result': '検索結果',
  'pages.pageAuthManagement.search.countUnit': '件',
  'pages.pageAuthManagement.reload': '再読込',
  'pages.pageAuthManagement.filter.keyword': '検索',
  'pages.pageAuthManagement.filter.all': '全部',
  'pages.pageAuthManagement.filter.department': '部門',
  'pages.pageAuthManagement.department.all': '全部',
  'pages.pageAuthManagement.department.humanResources': '人事部',
  'pages.pageAuthManagement.department.development': '開発部',
  'pages.pageAuthManagement.department.generalAffairs': '総務部',
  'pages.pageAuthManagement.department.sales': '営業部',
  'pages.pageAuthManagement.department.accounting': '経理部',
  'pages.pageAuthManagement.department.systemSettings': 'システム設定',
  'pages.pageAuthManagement.department.common': '共通',
  'pages.pageAuthManagement.permissionSummary.title': '権限概要',
  'pages.pageAuthManagement.permissionSummary.expandHint': '展開して確認',
  'pages.pageAuthManagement.permissionSummary.loading': '読込中',
  'pages.pageAuthManagement.permissionSummary.loaded': '{operationCount}権限 / {roleCount}ロール',
  'pages.pageAuthManagement.permissionSummary.empty': '権限情報がありません。',
  'pages.pageAuthManagement.permissionSummary.unset': '未設定',
  'pages.pageAuthManagement.load.failed': '画面一覧の取得に失敗しました。',
  'pages.pageAuthManagement.auth.loadFailed': '画面権限情報の取得に失敗しました。',
  'pages.pageAuthManagement.modal.title': '画面権限編集',
  'pages.pageAuthManagement.modal.operationCount': '操作数',
  'pages.pageAuthManagement.modal.selectedRoleCount': '選択中',
  'pages.pageAuthManagement.modal.readonly': '更新権限がないため、閲覧のみ可能です。',
  'pages.pageAuthManagement.action.save': '保存',
  'pages.pageAuthManagement.action.cancel': 'キャンセル',
  'pages.pageAuthManagement.action.saveAnyway': 'このまま保存',
  'pages.pageAuthManagement.emptyRole.confirmTitle': 'ロール未設定の操作があります。',
  'pages.pageAuthManagement.emptyRole.confirmDescription':
    '以下の操作はどのロールにも付与されません。このまま保存しますか？',
  'pages.pageAuthManagement.update.process': '画面権限更新中...',
  'pages.pageAuthManagement.update.done': '画面権限を更新しました。',
  'pages.pageAuthManagement.update.failed': '画面権限の更新に失敗しました。',

  // 社員一覧管理
  'pages.employeeList.employeeNo': '社員ID',
  'pages.employeeList.fullNameKanji': '社員名',
  'pages.employeeList.accountName': 'アカウント名',
  'pages.employeeList.division': '事业部',
  'pages.employeeList.department': '部署',
  'pages.employeeList.position': '役職',
  'pages.employeeList.contractType': '所属形態',
  'pages.employeeList.contractType.bpActiveTitle': '【契約中】',
  'pages.employeeList.joiningCompanyDate': '入社日',
  'pages.employeeList.contractPeriodFrom': '契約期間（開始）',
  'pages.employeeList.contractPeriodTo': '契約期間（終了）',
  'pages.employeeList.phone': '電話番号',
  'pages.employeeList.mailAddress': 'メール',
  'pages.employeeList.status': 'ステータス',
  'pages.employeeList.status.undefined': '未定',
  'pages.employeeList.operation': '操作',
  'pages.employeeList.update': '更新',
  'pages.employeeList.title': '社員一覧',
  // Dashboard
  'pages.dashboard.title': '人事データコントロールセンター',
  'pages.dashboard.subtitle': '社員ステータス、在留資格更新期限、要対応タスクのリアルタイム監視',
  'pages.dashboard.refresh': '更新',
  'pages.dashboard.quickAccess': 'クイックアクセス',
  'pages.dashboard.traineeList': '研修情報一覧',
  'pages.dashboard.regularList': '社員情報一覧',
  'pages.dashboard.bpList': 'BP情報一覧',
  'pages.dashboard.distribution': '社員構成比率',
  'pages.dashboard.distribution.regular': '正社員 / 契約',
  'pages.dashboard.distribution.trainee': '在籍 / 在校研修生',
  'pages.dashboard.distribution.bp': 'ビジネスパートナー (BP)',
  'pages.dashboard.historyTitle': '退職・退学履歴サマリー',
  'pages.dashboard.history.dropout': '退学研修生',
  'pages.dashboard.history.resigned': '退職正社員',
  'pages.dashboard.history.bpFinished': 'BPプロジェクト終了',
  'pages.dashboard.empty.title': 'すべての業務が完了しました！🎉',
  'pages.dashboard.empty.description':
    '期限の迫った在留資格更新や、面談待ち、契約満了のタスクはありません。',
  'pages.dashboard.visaRenewalDesc':
    '期限まで90日未満です。お早めに在留資格更新の手続きを進めてください。',
  'pages.dashboard.traineeVisaRenewalDesc':
    '在籍または在学の研修生の在留資格更新・変更の案内。審査資料の提出が必要です。',
  'pages.dashboard.interviewWaitDesc':
    '登用面談日程の調整。面接官への連絡とスケジュール調整を行います。',
  'pages.dashboard.contractWaitDesc':
    '契約社員および正社員の契約更新の事前連絡。意向確認と契約締結手続きを行います。',
  'pages.dashboard.total': '合計',
  'pages.dashboard.viewAll': 'すべて表示 →',
  'pages.dashboard.activeStatus': '在籍状況',
  'pages.dashboard.totalActive': '在籍総数',
  'pages.dashboard.trainee': '就職指向',
  'pages.dashboard.regular': '社員',
  'pages.dashboard.bp': 'BP社員',
  'pages.dashboard.terminated': '関係終了者',
  'pages.dashboard.dropout': '研修離脱',
  'pages.dashboard.resigned': '退職',
  'pages.dashboard.bpFinished': 'BP終了',
  'pages.dashboard.actionRequired': '要対応',
  'pages.dashboard.actionRequiredWorkplace': '要対応事務ワークプレイス',
  'pages.dashboard.actionRequiredDesc': '直ちに対応が必要です',
  'pages.dashboard.noActionRequired': 'すべての対応が完了しました',
  'pages.dashboard.visaRenewal': '在留更新 (90日以内)',
  'pages.dashboard.interviewWait': '登用面談待ち',
  'pages.dashboard.contractWait': '契約切替待ち',
  'pages.dashboard.birthdayThisMonth': '今月誕生日',
  'pages.dashboard.birthdayDesc': '今月の社員誕生日会 🍰',
  'pages.dashboard.noBirthdayDesc': '今月の誕生日社員はいません',
  'pages.dashboard.traineeVisaRenewal': '在留資格変更・更新',
  'pages.dashboard.pendingAlertTitle': '業務ステータス提示',
  'pages.dashboard.people': '人',
  'pages.dashboard.msg.loadFailed': 'ダッシュボードデータの読み込みに失敗しました。',
  'pages.dashboard.recruitmentPipeline': '採用・選考パイプライン',
  'pages.dashboard.upcomingInterviews': '近々の面接スケジュール',
  'pages.dashboard.pipeline.screening': '書類選考中',
  'pages.dashboard.pipeline.scheduled': '面接実施待ち',
  'pages.dashboard.pipeline.testing': 'テスト中・結果待ち',
  'pages.dashboard.pipeline.pending': '合否判定待ち',
  'pages.dashboard.interviews.empty': '予定されている面接はありません',
  'pages.dashboard.card.interview': '面接情報一覧',
  'pages.dashboard.card.trainee': '研修情報一覧',
  'pages.dashboard.card.regular': '社員情報一覧',
  'pages.dashboard.card.bp': 'BP社員情報一覧',
  'pages.dashboard.card.pending': '未定情報一覧',
  'pages.dashboard.undefinedAccounts': '未定情報アカウント一覧',
  'pages.dashboard.noUndefinedAccounts': '未定情報はありません',
  'pages.dashboard.accountStatus.disabled': '無効',
  'pages.dashboard.accountStatus.active': '有効',
  'pages.dashboard.viewAllUndefined': '未定情報リスト管理へ →',
  'pages.dashboard.undefinedMore': 'ほかに {count} 件あります。リストで確認してください。',
  'pages.dashboard.bpFinishedTitle': '契約終了履歴',
  //
  'pages.employeeList.trainee.title': '研修情報一覧',
  'pages.employeeList.regular.title': '社員情報一覧',
  'pages.employeeList.bp.title': 'BP社員情報一覧',
  'pages.employeeList.all': 'すべて',
  'pages.employeeList.total': '合計',
  'pages.employeeList.reload': '再読込',
  'pages.employeeList.terminationType': '関係終了者情報',
  'pages.employeeList.terminationType.bpFinishedTitle': '【契約終了】',
  'pages.employeeList.terminationType.dropout': '研修離脱',
  'pages.employeeList.terminationType.resigned': '退職',
  'pages.employeeList.terminationType.bpFinished': 'BP終了',
  'pages.employeeList.allActive': 'すべて（在職）',
  'pages.employeeList.allTerminated': 'すべて（関係終了者）',
  'pages.employeeList.regularConfirmStatus': '転正確認ステータス',
  'pages.employeeList.regularConfirmStatus.unconfirmed': '未確認',
  'pages.employeeList.regularConfirmStatus.confirmed': '確認OK',
  'pages.employeeList.regularConfirmStatus.rejected': '延期',
  'pages.employeeList.actionRequired': '要対応',
  'pages.employeeList.actionRequired.all': '要対応',
  'pages.employeeList.actionRequired.birthdayLastMonth': '上月生日',
  'pages.employeeList.actionRequired.birthdayThisMonth': '当月生日',
  'pages.employeeList.actionRequired.birthdayNextMonth': '下月生日',
  'pages.employeeList.actionRequired.visaRenewal90Days': '在留更新対象（90日以内）',
  'pages.employeeList.actionRequired.regularInterviewWait': '正社員登用面談待ち',
  'pages.employeeList.actionRequired.regularContractWait': '正社員契約切替待ち',
  'pages.employeeList.actionRequired.traineeVisaRenewal':
    '在留変更・更新対象（研修社員（内定者））',

  // 社員一覧管理 - 筛选标签
  'pages.employeeList.gender': '性別',
  'pages.employeeList.birthday': '生年月日',
  'pages.employeeList.age': '年齢',
  'pages.employeeList.yearsOfService': '勤続年数',
  'pages.employeeList.visaCardNo': '在留カード番号',
  'pages.employeeList.visaType': '在留カード資格',
  'pages.employeeList.visaValidTo': '有効期限',
  'pages.employeeList.remainingDays': '残り日数',
  'pages.employeeList.individualNumber': '個人番号',
  'pages.employeeList.bankAccount': '給料口座',
  'pages.employeeList.address': '住所',
  'pages.employeeList.remarks': '備考',

  // 社員一覧管理 - 性别
  'pages.employeeList.gender.unset': '未設定',
  'pages.employeeList.gender.male': '男性',
  'pages.employeeList.gender.female': '女性',
  'pages.employeeList.gender.other': 'その他',

  // 社員一覧管理 - 部门
  'pages.employeeList.department.dev1': '開発一部',
  'pages.employeeList.department.dev2': '開発二部',
  'pages.employeeList.department.accounting': '経理部',
  'pages.employeeList.department.hr': '人事部',
  'pages.employeeList.department.sales': '営業部',
  'pages.employeeList.department.ga': '総務部',
  'pages.employeeList.department.it': '情報システム部',
  'pages.employeeList.department.bp': 'BP社員',

  // 社員一覧管理 - 职位
  'pages.employeeList.position.member': '部員',
  'pages.employeeList.position.chief': '係長',
  'pages.employeeList.position.manager': '課長',
  'pages.employeeList.position.director': '部長',

  // 社員一覧管理 - 所属形態
  'pages.employeeList.contractType.trainee': '就職指向',
  'pages.employeeList.contractType.internal': '研修社員（内定者）',
  'pages.employeeList.contractType.contract': '契約社員',
  'pages.employeeList.contractType.regular': '正社員',
  'pages.employeeList.contractType.bp': 'BP社員',
  'pages.employeeList.contractType.bpStudy': 'BP社員在学',
  'pages.employeeList.contractType.bpEnrolled': 'BP社員在籍',

  // 社員一覧管理 - 编辑弹窗
  'pages.employeeList.edit.title': '社員情報編集',
  'pages.employeeList.edit.personalInfo': '個人情報',
  'pages.employeeList.edit.visaInfo': '在留情報',
  'pages.employeeList.edit.employmentInfo': '雇用情報',
  'pages.employeeList.edit.bankInfo': '銀行口座',
  'pages.employeeList.edit.remarks': '備考',
  'pages.employeeList.edit.basicInfo': '基本個人情報',
  'pages.employeeList.edit.contactInfo': '連絡先情報',
  'pages.employeeList.edit.contractInfo': '契約情報',
  'pages.employeeList.edit.orgInfo': '組織・期間情報',
  'pages.employeeList.edit.visaCardInfo': '在留カード情報',
  'pages.employeeList.edit.bankAccountInfo': '銀行口座情報',
  'pages.employeeList.edit.remarksInfo': '備考欄',

  // 表单字段标签
  'pages.employeeList.field.firstNameKanji': '姓(漢字)',
  'pages.employeeList.field.lastNameKanji': '名(漢字)',
  'pages.employeeList.field.firstNameKana': '姓(カナ)',
  'pages.employeeList.field.lastNameKana': '名(カナ)',
  'pages.employeeList.field.firstNameRoma': '姓(ローマ字)',
  'pages.employeeList.field.lastNameRoma': '名(ローマ字)',
  'pages.employeeList.field.gender': '性別',
  'pages.employeeList.field.birthday': '生年月日',
  'pages.employeeList.field.nationality': '国籍',
  'pages.employeeList.field.phone': '電話番号',
  'pages.employeeList.field.mobile': '携帯電話',
  'pages.employeeList.field.postalCode': '郵便番号',
  'pages.employeeList.field.mailAddress': 'メールアドレス',
  'pages.employeeList.field.address': '住所',
  'pages.employeeList.field.visaCardNo': '在留カード番号',
  'pages.employeeList.field.visaType': '在留資格',
  'pages.employeeList.field.visaValidTo': 'カード期限',
  'pages.employeeList.field.visaFromDate': '在留期間(開始)',
  'pages.employeeList.field.visaToDate': '在留期間(終了)',
  'pages.employeeList.field.individualNumber': '個人番号',
  'pages.employeeList.field.accountId': 'アカウントID',
  'pages.employeeList.field.division': '事業部',
  'pages.employeeList.field.contractType': '所属形態',
  'pages.employeeList.field.regularConfirmStatus': '転正確認',
  'pages.employeeList.field.department': '部署',
  'pages.employeeList.field.position': '役職',
  'pages.employeeList.field.joiningDate': '入社日',
  'pages.employeeList.field.departureDate': '退社日',
  'pages.employeeList.field.contractPeriodFrom': '契約期間(開始)',
  'pages.employeeList.field.contractPeriodTo': '契約期間(終了)',
  'pages.employeeList.field.employmentInsuranceNo': '雇用保険',
  'pages.employeeList.field.healthInsurerNo': '保険者番号',
  'pages.employeeList.field.healthInsuranceSymbol': '被保険者証記号',
  'pages.employeeList.field.healthInsuranceNo': '被保険者証番号',
  'pages.employeeList.healthInsurance.help':
    '3項目はすべて未入力でも保存できます。いずれかを入力する場合は、すべて入力してください。',
  'pages.employeeList.healthInsurance.incomplete':
    '健康保険情報を入力する場合は、保険者番号・被保険者証記号・被保険者証番号をすべて入力してください。',
  'pages.employeeList.healthInsurance.digitsOnly': '数字のみで入力してください。',
  'pages.employeeList.healthInsurance.maxLength': '30桁以内で入力してください。',
  'pages.employeeList.field.bankName': '銀行名',
  'pages.employeeList.field.bankBranch': '支店名',
  'pages.employeeList.field.bankAccountType': '口座種別',
  'pages.employeeList.field.bankAccountNo': '口座番号',
  'pages.employeeList.field.bankAccountHolder': '口座名義',
  'pages.employeeList.field.remarks': '備考',

  // 表单选项值
  'pages.employeeList.option.nationality.china': '中国',
  'pages.employeeList.option.nationality.japan': '日本',
  'pages.employeeList.option.nationality.other': 'その他',
  'pages.employeeList.option.division.hq': '本部',
  'pages.employeeList.option.division.ec': 'EC',
  'pages.employeeList.option.regularConfirm.unconfirmed': '未確認',
  'pages.employeeList.option.regularConfirm.confirmed': '確認OK',
  'pages.employeeList.option.regularConfirm.rejected': '延期',
  'pages.employeeList.option.accountType.normal': '普通',
  'pages.employeeList.option.accountType.current': '当座',
  'pages.employeeList.option.accountType.savings': '貯蓄',

  // 在留資格选项
  'pages.employeeList.visaType.unset': '未設定',
  'pages.employeeList.visaType.engineer': '技術・人文知識・国際業務',
  'pages.employeeList.visaType.highlySkilled1': '高度専門職1号',
  'pages.employeeList.visaType.highlySkilled2': '高度専門職2号',
  'pages.employeeList.visaType.business': '経営・管理',
  'pages.employeeList.visaType.intraCompany': '企業内転勤',
  'pages.employeeList.visaType.permanent': '永住者',
  'pages.employeeList.visaType.other': 'その他',

  // 按钮和消息
  'pages.employeeList.btn.cancel': 'キャンセル',
  'pages.employeeList.btn.save': '保存する',
  'pages.employeeList.btn.edit': '編集',
  'pages.employeeList.msg.loading': '再読込中...',
  'pages.employeeList.msg.reloadSuccess': '更新完了',
  'pages.employeeList.msg.searchFailed': '検索に失敗しました。',
  'pages.employeeList.msg.fetchFailed': '社員情報の取得に失敗しました。',
  'pages.employeeList.msg.saveSuccess': '保存しました。',
  'pages.employeeList.msg.saveFailed': '保存に失敗しました。',

  // 时间单位
  'pages.employeeList.unit.year': '年',
  'pages.employeeList.unit.month': 'ヶ月',
  'pages.employeeList.unit.day': '日',
  'pages.employeeList.status.expired': '期限切れ',

  // 学習管理 - プレイヤーページ
  'pages.learnPlayer.home': 'ホーム',
  'pages.learnPlayer.course': 'コース',
  'pages.learnPlayer.downloadMaterials': '材料ダウンロード',
  'pages.learnPlayer.backToHome': 'ホームページに戻る',
  'pages.learnPlayer.menuArea': 'メニュー領域',
  'pages.learnPlayer.testPage': 'テストページへ',
  'pages.learnPlayer.download': 'ダウンロード',
  'pages.learnPlayer.playlist': '再生リスト',
  'pages.learnPlayer.currentPlaying': '再生中',
  'pages.learnPlayer.questionSubmit': '問題提出',
  'pages.learnPlayer.title': 'タイトル',
  'pages.learnPlayer.titlePlaceholder': '問題タイトルを入力してください（5-30文字）',
  'pages.learnPlayer.titleRequired': 'タイトルを入力してください',
  'pages.learnPlayer.titleMin': 'タイトルは5文字以上で入力してください',
  'pages.learnPlayer.titleMax': 'タイトルは30文字以内で入力してください',
  'pages.learnPlayer.content': '内容',
  'pages.learnPlayer.contentPlaceholder': '問題内容を入力してください（10-20000文字）',
  'pages.learnPlayer.contentRequired': '問題内容を入力してください',
  'pages.learnPlayer.contentMin': '内容は10文字以上で入力してください',
  'pages.learnPlayer.contentMax': '内容は20000文字以内で入力してください',
  'pages.learnPlayer.attachments': '添付ファイル',
  'pages.learnPlayer.uploadFile': 'ファイルをアップロード',
  'pages.learnPlayer.submit': '提出',
  'pages.learnPlayer.submitSuccess': '問題が正常に提出されました',
  'pages.learnPlayer.qa': 'Q&A',
  'pages.learnPlayer.noQuestions': '問題がありません',
  'pages.learnPlayer.resolved': '解決済み',
  'pages.learnPlayer.unresolved': '未解決',
  'pages.learnPlayer.getCourseInfoFailed': 'コース情報の取得に失敗しました',
  'pages.learnPlayer.getQuestionsFailed': '問題リストの取得に失敗しました',
  'pages.learnPlayer.submitQuestionFailed': '問題の提出に失敗しました',
  'pages.learnPlayer.downloadFunctionPending': 'ダウンロード機能は実装待ちです',

  // 学習管理 - テストページ
  'pages.learnTest.testPage': 'テストページ',
  'pages.learnTest.test': 'テスト',
  'pages.learnTest.loading': '読み込み中...',
  'pages.learnTest.question': '問題',
  'pages.learnTest.singleChoice': '単一選択',
  'pages.learnTest.multipleChoice': '複数選択',
  'pages.learnTest.mark': 'マーク',
  'pages.learnTest.unmark': 'マーク解除',
  'pages.learnTest.previous': '前へ',
  'pages.learnTest.next': '次へ',
  'pages.learnTest.answerSheet': '解答シート',
  'pages.learnTest.answered': '回答済み',
  'pages.learnTest.current': '現在',
  'pages.learnTest.marked': 'マーク済み',
  'pages.learnTest.submit': '提出',
  'pages.learnTest.abandon': '放棄',
  'pages.learnTest.confirmSubmit': '提出を確認',
  'pages.learnTest.confirmSubmitContent':
    'テストの回答を提出してもよろしいですか？提出後は変更できません。',
  'pages.learnTest.confirmAbandon': '放棄を確認',
  'pages.learnTest.confirmAbandonContent':
    'テストを放棄してもよろしいですか？すべての回答がリセットされます。',
  'pages.learnTest.submitSuccess': 'テストが正常に提出されました',
  'pages.learnTest.submitFailed': 'テストの提出に失敗しました',
  'pages.learnTest.getTestInfoFailed': 'テスト情報の取得に失敗しました',
  'pages.learnTest.getQuestionsFailed': 'テスト問題の取得に失敗しました',
  'pages.learnTest.retryRequiredMessage':
    '正答率が60%未満のため、再学習が必要です。動画を最後まで視聴すると、再度テストを受けられます。',

  // 学習管理 - 質問ページ
  'pages.learnQuestion.questionPage': '*質問ページ',
  'pages.learnQuestion.answerQuestion': '質問に答える',
  'pages.learnQuestion.answerContent': '回答内容',
  'pages.learnQuestion.answerContentPlaceholder': '回答内容を入力してください（10-20000文字）',
  'pages.learnQuestion.answerContentRequired': '回答内容を入力してください',
  'pages.learnQuestion.answerContentMin': '内容は10文字以上で入力してください',
  'pages.learnQuestion.answerContentMax': '内容は20000文字以内で入力してください',
  'pages.learnQuestion.uploadFile': 'ファイルをアップロード',
  'pages.learnQuestion.cancel': 'キャンセル',
  'pages.learnQuestion.post': '投稿',
  'pages.learnQuestion.answers': '回答',
  'pages.learnQuestion.noAnswers': '回答がありません',
  'pages.learnQuestion.attachments': '添付ファイル：',
  'pages.learnQuestion.statusUpdateSuccess': 'ステータスが正常に更新されました',
  'pages.learnQuestion.answerSubmitSuccess': '回答が正常に提出されました',
  'pages.learnQuestion.answerSubmitFailed': '回答の提出に失敗しました',
  'pages.learnQuestion.getQuestionFailed': '質問の詳細取得に失敗しました',
  'pages.learnQuestion.getAnswersFailed': '回答リストの取得に失敗しました',

  // 学習管理 - 受講者進捗一覧
  'pages.learnProgress.title': '受講者進捗一覧',
  'pages.learnProgress.courseProgressTab': 'コース進捗別',
  'pages.learnProgress.scheduleProgressTab': '日付スケジュール別',
  'pages.learnProgress.courseProgressHeader': '受講者進捗一覧（コース進捗別）',
  'pages.learnProgress.scheduleProgressHeader': '受講者進捗一覧（日付スケジュール別）',
  'pages.learnProgress.participantName': '受講者名',
  'pages.learnProgress.department': '所属',
  'pages.learnProgress.completionRate': '完了率',
  'pages.learnProgress.learningHours': '学習時間',
  'pages.learnProgress.progressStatus': '進捗状況',
  'pages.learnProgress.academicYear': '受講年度',
  'pages.learnProgress.trainingCourse': '研修コース',
  'pages.learnProgress.class': 'クラス',
  'pages.learnProgress.status': 'ステータス',
  'pages.learnProgress.dateRange': '期間',
  'pages.learnProgress.today': '本日',
  'pages.learnProgress.statusNotStarted': '未着手',
  'pages.learnProgress.statusInProgress': '進行中',
  'pages.learnProgress.statusCompleted': '完了',
  'pages.learnProgress.statusOverdue': '期限超過',
  'pages.learnProgress.courseProgressDesc': '受講者ごとのコース別進捗を確認できます',
  'pages.learnProgress.scheduleProgressDesc': '受講者ごとの日付別進捗を確認できます',

  // 学習管理 - 研修データ分析 - レベル称号
  'pages.learnAnalytics.levelTitle.SSR': '伝説のフルスタック',
  'pages.learnAnalytics.levelTitle.SS': 'バグ即死スナイパー',
  'pages.learnAnalytics.levelTitle.S': '仕様書ちゃんと読む人',
  'pages.learnAnalytics.levelTitle.A': '真面目コミット職人',
  'pages.learnAnalytics.levelTitle.B': 'とりあえず動けば勢',
  'pages.learnAnalytics.levelTitle.C': 'デバッグ沼ダイバー',
  'pages.learnAnalytics.levelTitle.D': 'コンパイルエラー職人',
  'pages.learnAnalytics.levelTitle.E': 'PC再起動マスター',

  // 学習管理 - 研修データ分析
  'pages.development.learnManagement.analytics.participantName': '受講者名',
  'pages.development.learnManagement.analytics.department': '所属',
  'pages.development.learnManagement.analytics.level': 'レベル',
  'pages.development.learnManagement.analytics.totalScore': '総合スコア',
  'pages.development.learnManagement.analytics.points': '点',
  'pages.development.learnManagement.analytics.averageCompletionRate': '平均完了率',
  'pages.development.learnManagement.analytics.averageCorrectRate': '平均正答率',
  'pages.development.learnManagement.player.testAfterLearning': '学習後テスト',
  'pages.development.learnManagement.player.testLockedTooltip':
    '動画を最後まで学習するとテストを受験できます。',
  'pages.development.learnManagement.analytics.learningHours': '学習時間',
  'pages.development.learnManagement.analytics.hours': 'h',
  'pages.development.learnManagement.analytics.timeScore': '時間スコア',
  'pages.development.learnManagement.analytics.statusStatistics': 'ステータス統計',
  'pages.development.learnManagement.analytics.recalculateLevel': 'レベル再計算',
  'pages.development.learnManagement.analytics.recalculateSuccess': 'レベル再計算が完了しました',
  'pages.development.learnManagement.analytics.recalculateFailed': 'レベル再計算に失敗しました',
  'pages.development.learnManagement.analytics.statusStatisticsError': '状态统计数据获取失败',
  'pages.development.learnManagement.analytics.total': '合計',
  'pages.development.learnManagement.analytics.person': '人',
  'pages.development.learnManagement.analytics.personUnit': '人',
  'pages.development.learnManagement.analytics.academicYear': '受講年度',
  'pages.development.learnManagement.analytics.selectAcademicYear': '受講年度を選択',
  'pages.development.learnManagement.analytics.class': 'クラス',
  'pages.development.learnManagement.analytics.className': 'クラス名',
  'pages.development.learnManagement.analytics.selectClass': 'クラスを選択',
  'pages.development.learnManagement.analytics.completionStatus': '完了状態',
  'pages.development.learnManagement.analytics.notCompleted': '未完了',
  'pages.development.learnManagement.analytics.completed': '完了',

  // 学習管理 - 受講者進捗一覧
  'pages.development.learnManagement.progress.title': '受講者進捗一覧',
  'pages.development.learnManagement.progress.courseProgressTab': 'コース進捗別',
  'pages.development.learnManagement.progress.testTab': '中コーステスト',
  'pages.development.learnManagement.progress.courseProgressHeader':
    '受講者進捗一覧（コース進捗別）',
  'pages.development.learnManagement.progress.testProgressHeader':
    '受講者進捗一覧（中コーステスト）',
  'pages.development.learnManagement.progress.participantName': '受講者名',
  'pages.development.learnManagement.progress.completionRate': '完了率',
  'pages.development.learnManagement.progress.learningHours': '学習時間',
  'pages.development.learnManagement.progress.testName': 'テスト名',
  'pages.development.learnManagement.progress.score': '点数',
  'pages.development.learnManagement.progress.passFail': '合否',
  'pages.development.learnManagement.progress.completedDate': '完了日',
  'pages.development.learnManagement.progress.academicYear': '受講年度',
  'pages.development.learnManagement.progress.status': 'ステータス',
  'pages.development.learnManagement.progress.selectAcademicYear': '受講年度を選択',
  'pages.development.learnManagement.progress.selectStatus': 'ステータスを選択',
  'pages.development.learnManagement.progress.selectParticipantName': '受講者名を選択',
  'pages.development.learnManagement.progress.selectTestName': 'テスト名を選択',
  'pages.development.learnManagement.progress.passed': '是否合格',
  'pages.development.learnManagement.progress.selectPassed': '是否合格を選択',
  'pages.development.learnManagement.progress.notTaken': '未受験',
  'pages.development.learnManagement.progress.passedStatus': '合格',
  'pages.development.learnManagement.progress.failed': '不合格',
  'pages.development.learnManagement.progress.listView': 'リスト表示',
  'pages.development.learnManagement.progress.matrixView': 'マトリックス表示',
  'pages.development.learnManagement.progress.filterOptionsError': '筛选选项获取失败',
  'pages.development.learnManagement.progress.matrixTitle': '中コーステスト题目 / 受講者',
  'pages.development.learnManagement.progress.testDescription':
    '受講者ごとのテスト成績を確認できます',
  'pages.development.learnManagement.progress.noData':
    'データがありません。先にテスト成績データを読み込んでください。',
  'pages.development.learnManagement.progress.matrixDescription':
    "* 点数 ≥80 は緑色でハイライト；≥60 は青色；<60 は赤色で太字。未受験は '-' を表示。マトリックス表示により、各受講者の成績を横方向に比較できます。",
  'pages.development.learnManagement.progress.statusNotStarted': '未着手',
  'pages.development.learnManagement.progress.statusInProgress': '進行中',
  'pages.development.learnManagement.progress.statusCompleted': '完了',
  'pages.development.learnManagement.progress.statusOverdue': '期限超過',

  // 学習管理 - コース管理
  'pages.development.learnManagement.course.largeCourseTab': '大课程',
  'pages.development.learnManagement.course.mediumCourseTab': '中课程',
  'pages.development.learnManagement.course.largeCourse': '大课程',
  'pages.development.learnManagement.course.mediumCourse': '中课程',
  'pages.development.learnManagement.course.largeCourseName': '大课程名',
  'pages.development.learnManagement.course.largeCourseDescription': '大课程説明',
  'pages.development.learnManagement.course.mediumCourseName': '中课程名',
  'pages.development.learnManagement.course.mediumCourseCode': '中课程コード',
  'pages.development.learnManagement.course.mediumCourseDescription': '中课程説明',
  'pages.development.learnManagement.course.smallCourseCount': '小课程数',
  'pages.development.learnManagement.course.learningProgressName': '学習進捗名',
  'pages.development.learnManagement.course.learningTimeMinutes': '学習時間(分)',
  'pages.development.learnManagement.course.practiceQuestionCount': '練習問題数',
  'pages.development.learnManagement.course.createdDate': '作成日時',
  'pages.development.learnManagement.course.createDate': '作成日時',
  'pages.development.learnManagement.course.operation': '操作',
  'pages.development.learnManagement.course.update': '更新',
  'pages.development.learnManagement.course.delete': '削除',
  'pages.development.learnManagement.course.addLargeCourse': '大课程追加',
  'pages.development.learnManagement.course.addMediumCourse': '中课程追加',
  'pages.development.learnManagement.course.addSmallCourse': '小课程追加',
  'pages.development.learnManagement.course.largeCourseAdd': '大课程追加',
  'pages.development.learnManagement.course.mediumCourseAdd': '中课程追加',
  'pages.development.learnManagement.course.smallCourseAdd': '小課程追加',
  'pages.development.learnManagement.course.batchDelete': '一括削除',
  'pages.development.learnManagement.course.testManagement': 'テスト管理',
  'pages.development.learnManagement.course.largeCourseManagement': '大课程管理',
  'pages.development.learnManagement.course.mediumCourseManagement': '中课程管理',
  'pages.development.learnManagement.course.smallCourseList': '小課程一覧',
  'pages.development.learnManagement.course.largeCourseDeleteConfirm': '大課程削除確認',
  'pages.development.learnManagement.course.largeCourseDeleteDescription':
    'この大課程を削除してもよろしいですか？',
  'pages.development.learnManagement.course.largeCourseDeleteConfirmTitle': '大課程削除確認',
  'pages.development.learnManagement.course.largeCourseDeleteConfirmDescription':
    'この大課程を削除してもよろしいですか？',
  'pages.development.learnManagement.course.mediumCourseDeleteConfirm': '中課程削除確認',
  'pages.development.learnManagement.course.mediumCourseDeleteDescription':
    'この中課程を削除してもよろしいですか？',
  'pages.development.learnManagement.course.mediumCourseDeleteConfirmTitle': '中課程削除確認',
  'pages.development.learnManagement.course.mediumCourseDeleteConfirmDescription':
    'この中課程を削除してもよろしいですか？',
  'pages.development.learnManagement.course.smallCourseDeleteConfirm': '小課程削除確認',
  'pages.development.learnManagement.course.smallCourseDeleteDescription':
    'この小課程を削除してもよろしいですか？',
  'pages.development.learnManagement.course.smallCourseDeleteConfirmTitle': '小課程削除確認',
  'pages.development.learnManagement.course.smallCourseDeleteConfirmDescription':
    'この小課程を削除してもよろしいですか？',
  'pages.development.learnManagement.course.cancel': 'キャンセル',
  'pages.development.learnManagement.course.largeCourseDeleting': '大課程を削除中...',
  'pages.development.learnManagement.course.largeCourseDeleted':
    '大課程を削除しました、まもなく更新されます。',
  'pages.development.learnManagement.course.largeCourseDeleteFailed': '大課程の削除に失敗しました',
  'pages.development.learnManagement.course.largeCourseAdding': '大課程を追加中...',
  'pages.development.learnManagement.course.largeCourseAdded': '大課程を追加しました。',
  'pages.development.learnManagement.course.largeCourseAddFailed': '大課程の追加に失敗しました',
  'pages.development.learnManagement.course.largeCourseUpdating': '大課程を更新中...',
  'pages.development.learnManagement.course.largeCourseUpdated': '大課程を更新しました。',
  'pages.development.learnManagement.course.largeCourseUpdateFailed': '大課程の更新に失敗しました',
  'pages.development.learnManagement.course.mediumCourseDeleting': '中課程を削除中...',
  'pages.development.learnManagement.course.mediumCourseDeleted':
    '中課程を削除しました、まもなく更新されます。',
  'pages.development.learnManagement.course.mediumCourseDeleteFailed': '中課程の削除に失敗しました',
  'pages.development.learnManagement.course.mediumCourseAdding': '中課程を追加中...',
  'pages.development.learnManagement.course.mediumCourseAdded': '中課程を追加しました。',
  'pages.development.learnManagement.course.mediumCourseAddFailed': '中課程の追加に失敗しました',
  'pages.development.learnManagement.course.mediumCourseUpdating': '中課程を更新中...',
  'pages.development.learnManagement.course.mediumCourseUpdated': '中課程を更新しました。',
  'pages.development.learnManagement.course.mediumCourseUpdateFailed': '中課程の更新に失敗しました',
  'pages.development.learnManagement.course.smallCourseDeleting': '小課程を削除中...',
  'pages.development.learnManagement.course.smallCourseDeleted':
    '小課程を削除しました、まもなく更新されます。',
  'pages.development.learnManagement.course.smallCourseDeleteFailed': '小課程の削除に失敗しました',
  'pages.development.learnManagement.course.smallCourseAdding': '小課程を追加中...',
  'pages.development.learnManagement.course.smallCourseAdded': '小課程を追加しました。',
  'pages.development.learnManagement.course.smallCourseAddFailed': '小課程の追加に失敗しました',
  'pages.development.learnManagement.course.smallCourseUpdating': '小課程を更新中...',
  'pages.development.learnManagement.course.smallCourseUpdated': '小課程を更新しました。',
  'pages.development.learnManagement.course.smallCourseUpdateFailed': '小課程の更新に失敗しました',
  'pages.development.learnManagement.course.mediumCourseListError': '中課程リスト取得エラー',
  'pages.development.learnManagement.course.largeCourseUpdate': '大課程更新',
  'pages.development.learnManagement.course.largeCourseUpdateTitle': '大課程更新',
  'pages.development.learnManagement.course.largeCourseAddTitle': '大課程追加',
  'pages.development.learnManagement.course.largeCourseNamePlaceholder':
    '例: フロントエンド基礎パック (HTML/CSS/JavaScript)',
  'pages.development.learnManagement.course.largeCourseNameRequired': '大課程名を入力してください',
  'pages.development.learnManagement.course.largeCourseDescriptionPlaceholder':
    '大課程の説明を入力してください',
  'pages.development.learnManagement.course.relatedMediumCourses': '关联中課程',
  'pages.development.learnManagement.course.relatedMediumCoursesPlaceholder':
    '中課程を選択してください（複数選択可）',
  'pages.development.learnManagement.course.selectMediumCourses':
    '中課程を選択してください（複数選択可）',
  'pages.development.learnManagement.course.mediumCourseUpdateTitle': '中課程更新',
  'pages.development.learnManagement.course.mediumCourseAddTitle': '中課程追加',
  'pages.development.learnManagement.course.mediumCourseNamePlaceholder':
    '中課程名を入力してください',
  'pages.development.learnManagement.course.mediumCourseNameRequired': '中課程名を入力してください',
  'pages.development.learnManagement.course.mediumCourseCodePlaceholder': '例: HTML',
  'pages.development.learnManagement.course.mediumCourseDescriptionPlaceholder':
    '中課程の説明を入力してください',
  'pages.development.learnManagement.course.mediumCourseStage': '段階',
  'pages.development.learnManagement.course.mediumCourseStagePlaceholder': '段階を選択してください',
  'pages.development.learnManagement.course.stage1': '段階1：フロントエンド学習',
  'pages.development.learnManagement.course.stage2': '第二段',
  'pages.development.learnManagement.course.relatedLargeCourseId': '関連大課程ID',
  'pages.development.learnManagement.course.relatedLargeCourseIdPlaceholder':
    '関連大課程IDを入力してください（オプション）',
  'pages.development.learnManagement.course.trainingCourseId': '研修コースID',
  'pages.development.learnManagement.course.trainingCourseIdPlaceholder':
    '研修コースIDを入力してください',
  'pages.development.learnManagement.course.trainingCourseIdRequired':
    '研修コースIDを入力してください',
  'pages.development.learnManagement.course.courseStructure': 'コース構造',
  'pages.development.learnManagement.course.courseStructurePlaceholder':
    'コース構造を入力してください',
  'pages.development.learnManagement.course.smallCourseUpdateTitle': '小課程更新',
  'pages.development.learnManagement.course.smallCourseAddTitle': '小課程追加',
  'pages.development.learnManagement.course.selectMediumCourse': '中課程を選択してください',
  'pages.development.learnManagement.course.mediumCourseSelectPlaceholder':
    '中課程を選択してください',
  'pages.development.learnManagement.course.mediumCourseRequired': '中課程を選択してください',
  'pages.development.learnManagement.course.smallCourseName': '小課程名',
  'pages.development.learnManagement.course.smallCourseNamePlaceholder':
    '小課程名を入力してください',
  'pages.development.learnManagement.course.smallCourseNameRequired': '小課程名を入力してください',
  'pages.development.learnManagement.course.smallCourseDescription': '小課程説明',
  'pages.development.learnManagement.course.smallCourseDescriptionPlaceholder':
    '小課程の説明を入力してください',
  'pages.development.learnManagement.course.learningProgressNamePlaceholder':
    '学習進捗名を入力してください',
  'pages.development.learnManagement.course.learningProgressNameRequired':
    '学習進捗名を入力してください',
  'pages.development.learnManagement.course.learningTimePlaceholder': '学習時間を入力してください',
  'pages.development.learnManagement.course.learningTimeRequired': '学習時間を入力してください',
  'pages.development.learnManagement.course.learningTimeMinutesPlaceholder':
    '学習時間(分)を入力してください',
  'pages.development.learnManagement.course.learningTimeMinutesRequired':
    '学習時間(分)を入力してください',
  'pages.development.learnManagement.course.smallCourseMinutes': '小課程時間(分)',
  'pages.development.learnManagement.course.smallCourseMinutesPlaceholder':
    '小課程時間(分)を入力してください',
  'pages.development.learnManagement.course.smallCourseMinutesRequired':
    '小課程時間(分)を入力してください',
  'pages.development.learnManagement.course.practiceQuestionCountPlaceholder':
    '練習問題数を入力してください',
  'pages.development.learnManagement.course.practiceQuestionCountRequired':
    '練習問題数を入力してください',
  'pages.development.learnManagement.course.smallCourseUrl': '小課程URL',
  'pages.development.learnManagement.course.smallCourseUrlPlaceholder':
    '小課程URLを入力してください',
  'pages.development.learnManagement.course.smallCourseUrlRequired': '小課程URLを入力してください',
  'pages.development.learnManagement.course.orderNo': '順序番号',
  'pages.development.learnManagement.course.orderNoPlaceholder':
    '順序番号を入力してください（オプション）',
  'pages.development.learnManagement.course.no': '番号',
  'pages.development.learnManagement.course.testManagementTitle': 'テスト管理',
  'pages.development.learnManagement.course.smallCourseId': '小課程ID',
  'pages.development.learnManagement.course.questionDeleted': '题目を削除しました',
  'pages.development.learnManagement.course.questionDeleteFailed': '题目の削除に失敗しました',
  'pages.development.learnManagement.course.questionUpdated': '题目を更新しました',
  'pages.development.learnManagement.course.questionAdded': '题目を追加しました',
  'pages.development.learnManagement.course.operationFailed': '操作に失敗しました',
  'pages.development.learnManagement.course.questionDeleteConfirm': '题目削除確認',
  'pages.development.learnManagement.course.questionDeleteDescription':
    'この题目を削除してもよろしいですか？',
  'pages.development.learnManagement.course.questionEdit': '题目編集',
  'pages.development.learnManagement.course.questionAdd': '题目追加',
  'pages.development.learnManagement.course.addQuestion': '题目增加',
  'pages.development.learnManagement.course.edit': '編集',
  'pages.development.learnManagement.course.questionContent': '题目内容',
  'pages.development.learnManagement.course.questionContentPlaceholder':
    '题目内容を入力してください',
  'pages.development.learnManagement.course.questionContentRequired': '题目内容を入力してください',
  'pages.development.learnManagement.course.questionType': '题目タイプ',
  'pages.development.learnManagement.course.questionTypeRequired': '题目タイプを選択してください',
  'pages.development.learnManagement.course.singleChoice': '単一選択',
  'pages.development.learnManagement.course.multipleChoice': '多選択',
  'pages.development.learnManagement.course.addOption': '选项追加',
  'pages.development.learnManagement.course.option': '选项{index}',
  'pages.development.learnManagement.course.optionPlaceholder': '选项{index}を入力してください',
  'pages.development.learnManagement.course.optionContentRequired': '选项内容を入力してください',
  'pages.development.learnManagement.course.optionsMinRequired': '少なくとも2つの选项が必要です',
  'pages.development.learnManagement.course.correctAnswer': '正解',
  'pages.development.learnManagement.course.correctAnswerRequired': '正解を選択してください',
  'pages.development.learnManagement.course.correctAnswerAtLeastOneRequired':
    '少なくとも1つの正解を選択してください',
  'pages.development.learnManagement.course.optionCount': '选项数',
  'pages.development.learnManagement.course.questionDeleteConfirmTitle': '题目削除確認',
  'pages.development.learnManagement.course.questionDeleteConfirmDescription':
    'この题目を削除してもよろしいですか？',
  'pages.development.learnManagement.course.smallCourseUpdate': '小課程更新',
  'pages.development.learnManagement.course.selectedItems': '已选择',
  'pages.development.learnManagement.course.items': '項',
  'pages.development.learnManagement.course.qaManagement': 'QA管理',
  'pages.development.learnManagement.course.mediumCourseId': '中課程ID',
  'pages.development.learnManagement.course.qaContent': 'QA内容',
  'pages.development.learnManagement.course.questionerName': '質問者名',
  'pages.development.learnManagement.course.manageAnswers': '回答管理',
  'pages.development.learnManagement.course.addQa': 'QA追加',
  'pages.development.learnManagement.course.qaAnswerDeleted': '小課程QA回答を削除しました',
  'pages.development.learnManagement.course.qaAnswerDeleteFailed': '削除に失敗しました',
  'pages.development.learnManagement.course.qaAnswerUpdated': '小課程QA回答を更新しました',
  'pages.development.learnManagement.course.qaAnswerAdded': '小課程QA回答を登録しました',
  'pages.development.learnManagement.course.questionId': '問題ID',
  'pages.development.learnManagement.course.accountId': 'アカウントID',
  'pages.development.learnManagement.course.answerResult': '回答結果',
  'pages.development.learnManagement.course.answerCorrect': '正解',
  'pages.development.learnManagement.course.answerIncorrect': '不正解',
  'pages.development.learnManagement.course.score': '成績',
  'pages.development.learnManagement.course.editAnswer': '回答を編集',
  'pages.development.learnManagement.course.smallCourseQuestionId': '小課程問題ID',
  'pages.development.learnManagement.course.smallCourseQuestionIdRequired':
    '小課程問題IDを入力してください',
  'pages.development.learnManagement.course.accountIdRequired': 'アカウントIDを入力してください',
  'pages.development.learnManagement.course.answerContentLabel': '回答内容 (A/B/C/D)',
  'pages.development.learnManagement.course.answerContentPattern':
    'A, B, C, D のいずれかを入力してください',
  'pages.development.learnManagement.course.answerContentPlaceholder':
    'ユーザーが選択した答え (A/B/C/D)',
  'pages.development.learnManagement.course.answerResultPlaceholder':
    '回答結果を入力 (0=不正解, 1=正解)',
  'pages.development.learnManagement.course.scorePlaceholder': '成績を入力',
  'pages.development.learnManagement.course.qaContentPlaceholder': 'QA内容を入力してください',
  'pages.development.learnManagement.course.qaContentRequired': 'QA内容を入力してください',
  'pages.development.learnManagement.course.qaAnswer': 'QA回答',
  'pages.development.learnManagement.course.qaAnswerPlaceholder': 'QA回答を入力してください',
  'pages.development.learnManagement.course.qaAnswerRequired': 'QA回答を選択してください',
  'pages.development.learnManagement.course.qaComment': 'QA備考',
  'pages.development.learnManagement.course.qaCommentPlaceholder': 'QA備考を入力してください',
  'pages.development.learnManagement.course.qaChooseA': '選択肢A',
  'pages.development.learnManagement.course.qaChooseAPlaceholder': '選択肢Aを入力してください',
  'pages.development.learnManagement.course.qaChooseARequired': '選択肢Aを入力してください',
  'pages.development.learnManagement.course.qaChooseB': '選択肢B',
  'pages.development.learnManagement.course.qaChooseBPlaceholder': '選択肢Bを入力してください',
  'pages.development.learnManagement.course.qaChooseBRequired': '選択肢Bを入力してください',
  'pages.development.learnManagement.course.qaChooseC': '選択肢C',
  'pages.development.learnManagement.course.qaChooseCPlaceholder': '選択肢Cを入力してください',
  'pages.development.learnManagement.course.qaChooseCRequired': '選択肢Cを入力してください',
  'pages.development.learnManagement.course.qaChooseD': '選択肢D',
  'pages.development.learnManagement.course.qaChooseDPlaceholder': '選択肢Dを入力してください',
  'pages.development.learnManagement.course.qaChooseDRequired': '選択肢Dを入力してください',
  'pages.development.learnManagement.course.qaDeleteConfirmTitle': 'QA削除確認',
  'pages.development.learnManagement.course.qaDeleteConfirmDescription':
    'このQAを削除してもよろしいですか？',
  'pages.development.learnManagement.course.mediumCourseRelationManagement': '中課程関連管理',
  'pages.development.learnManagement.course.relationManagementTitle': 'コース情報編集',
  'pages.development.learnManagement.course.reset': 'リセット',
  'pages.development.learnManagement.course.confirm': '確認',
  'pages.development.learnManagement.course.relationLoadFailed': '関連情報の読み込みに失敗しました',
  'pages.development.learnManagement.course.relationUpdated': '関連関係が正常に更新されました',
  'pages.development.learnManagement.course.relationUpdateFailed': '関連の更新に失敗しました',

  // 学習管理 - プレイヤー
  'pages.development.learnManagement.player.saveProgressSuccess': '学習進捗を保存しました',
  'pages.development.learnManagement.player.saveProgressFailed': '学習進捗の保存に失敗しました',
  'pages.development.learnManagement.player.testIdNotSet': 'テストIDが設定されていません',
  'pages.development.learnManagement.player.videoUrlNotSet': '動画URLが設定されていません',
  'pages.development.learnManagement.player.test': 'テスト',
  'pages.development.learnManagement.player.play': '再生',
  'pages.development.learnManagement.player.completeVideoFirst': 'Please先完成 video watching',
  'pages.development.learnManagement.player.currentSection': '現在のセクション',
  'pages.development.learnManagement.player.cancel': 'キャンセル',
  'pages.development.learnManagement.player.confirm': '確認',
  // Course Player
  'pages.development.learnManagement.player.mediumCourseIdNotFound': '中課程IDが存在しません',
  'pages.development.learnManagement.player.smallCourseCount': '小課程数',
  'pages.development.learnManagement.player.loading': '読み込み中...',
  'pages.development.learnManagement.player.noCurrentTask': '現在のタスクはありません',
  'pages.development.learnManagement.player.task': 'タスク',
  'pages.development.learnManagement.player.courseAndTest': '受講・テスト',
  'pages.development.learnManagement.player.mediumCourseTest': '中課程テスト',

  // Learn Progress
  'pages.development.learnManagement.progress.participantNameInput': '受講者名を入力してください',
  'pages.development.learnManagement.progress.level': '受講者レベル',
  'pages.development.learnManagement.progress.levelSelect': 'レベルを選択してください',
  'pages.development.learnManagement.progress.level1': 'レベル 1',
  'pages.development.learnManagement.progress.level2': 'レベル 2',
  'pages.development.learnManagement.progress.level3': 'レベル 3',
  'pages.development.learnManagement.progress.level4': 'レベル 4',
  'pages.development.learnManagement.progress.level5': 'レベル 5',
  'pages.development.learnManagement.progress.statusExcellent': '優秀 · 安定',
  'pages.development.learnManagement.progress.statusGood': '良好 · 観察',
  'pages.development.learnManagement.progress.statusAverage': '普通 · フォロー必要',
  'pages.development.learnManagement.progress.statusFail': 'リスク · 重点介入',
  'pages.development.learnManagement.progress.statusBomb': 'リスク · 重点介入',
  'pages.development.learnManagement.progress.levelAndScore': 'レベル・平均点',
  'pages.development.learnManagement.progress.averageScore': '平均点',
  'pages.development.learnManagement.progress.learningTask': '学習タスク',
  'pages.development.learnManagement.progress.learningRemark': '評価備考',
  'pages.development.learnManagement.progress.operation': '操作',
  'pages.development.learnManagement.progress.noPermission': '権限がありません',
  'pages.development.learnManagement.progress.taskManagement': 'タスク管理',
  'pages.development.learnManagement.progress.remarkManagement': '評価備考管理',
  'pages.development.learnManagement.progress.mediumCourseName': '中課程名',
  'pages.development.learnManagement.progress.mediumCourseNameSelect': '中課程名を選択してください',
  'pages.development.learnManagement.progress.participantNameInputExample':
    '例：田中太郎 / Zhang San',
  'pages.development.learnManagement.progress.recalcComplete':
    '再計算完了: 処理対象 {processedAccounts}, 新規 {insertedCount}, 更新 {updatedCount}',
  'pages.development.learnManagement.progress.recalc': '再計算',
  'pages.development.learnManagement.progress.taskInputRequired': '学習タスクを入力してください',
  'pages.development.learnManagement.progress.taskUpdated': 'タスクを更新しました',
  'pages.development.learnManagement.progress.taskInputPlaceholder': '学習タスクを入力',
  // 営業部 - 請求書一覧
  'pages.invoiceList.invoice': '請求書',
  'pages.invoiceList.payment': '入金予定',
  'pages.invoiceList.operation': '操作',
  'pages.invoiceList.invoiceCreate': '請求書作成',
  'pages.invoiceList.invoiceCreate.all': '請求書一括作成',
  'pages.invoiceList.create.process': '請求書作成中・・・',
  'pages.invoiceList.create.done': '請求書作成しました。',
  'pages.invoiceList.invoice.update': '請求書訂正',
  'pages.invoiceList.invoice.update.process': '請求書更新中・・・',
  'pages.invoiceList.invoice.update.done': '請求書更新しました。',
  'pages.invoiceList.payment.update': '入金状態更新',
  'pages.invoiceList.payment.update.process': '入金状態更新中・・・',
  'pages.invoiceList.payment.update.done': '入金状態更新しました。',
  'pages.development.learnManagement.progress.remarkUpdated': '備考を更新しました',
  'pages.development.learnManagement.progress.remarkInputPlaceholder':
    '評価・所見などを入力してください（例：学習意欲が高い、チームワークが良い等）',
  'pages.development.learnManagement.progress.remarkHint':
    '※ 受講者の評価、所見、アドバイスなどを自由に記入できます',

  // 総務部 - 交通費一覧
  'pages.commuteList.title': '交通費一覧',
  'pages.commuteList.employeeId': '社員ID',
  'pages.commuteList.progress': '進捗',
  'pages.commuteList.employeeName': '社員名',
  'pages.commuteList.amount': '金額',
  'pages.commuteList.submitStatus': '提出状態',
  'pages.commuteList.approvalStatus': '承認状態',
  'pages.commuteList.operation': '操作',
  'pages.commuteList.detail': '詳細',
  'pages.commuteList.remind': '提醒',
  'pages.commuteList.remindConfirm': 'リマインダー送信確認',
  'pages.commuteList.remindConfirmContent': '「{name}」に提出リマインダーを送信しますか？',
  'pages.commuteList.remindSuccess': 'リマインダーを送信しました',
  'pages.commuteList.remindFailed': 'リマインダー送信に失敗しました',
  'pages.commuteList.all': 'すべて',
  'pages.commuteList.notApplied': '未申請',
  'pages.commuteList.notAllSubmitted': '提出中',
  'pages.commuteList.allSubmitted': '承認待ち',
  'pages.commuteList.approved': '完了',
  'pages.commuteList.total': '合計',
  'pages.commuteList.reload': '再読込',
  'pages.commuteList.search.button': '検索',
  'pages.commuteList.search.placeholder':
    '社員ID / アカウント名 / 社員名 / 提出状態 / 承認状態 / 金額で検索',
  'pages.commuteList.search.result': '検索結果',
  'pages.commuteList.search.countUnit': '件',
  'pages.commuteList.remindAll': '一键提醒',
  'pages.commuteList.noPermission': 'この機能を使用する権限がありません。',
  'pages.commuteList.fetchFailed': '交通費一覧の取得に失敗しました。',
  'pages.commuteCommit.status.notSubmitted': '未提出',
  'pages.commuteCommit.status.pendingApproval': '承認待ち',
  'pages.commuteCommit.status.approved': '承認済み',
  'pages.commuteCommit.status.rejected': '差戻し',
  'pages.commuteCommit.reject.action': '不承認',
  'pages.commuteCommit.reject.title': '交通費不承認（差戻し）',
  'pages.commuteCommit.reject.placeholder': '差戻し理由を入力してください',
  'pages.commuteCommit.reject.ok': '差戻し',
  'pages.commuteCommit.reject.cancel': 'キャンセル',
  'pages.commuteCommit.reject.requireReason': '差戻し理由を入力してください。',
  'pages.commuteCommit.column.no': 'No',
  'pages.commuteCommit.column.commuteType': '交通費区分',
  'pages.commuteCommit.column.period': '期間',
  'pages.commuteCommit.column.amount': '金額',
  'pages.commuteCommit.column.status': '承認状態',
  'pages.commuteCommit.column.remarks': '備考',
  'pages.commuteCommit.column.receipt': '領収書',
  'pages.commuteCommit.column.actions': '操作',
  'pages.commuteCommit.receipt.show': '表示',
  'pages.commuteCommit.receipt.none': '領収書無し',
  'pages.commuteCommit.action.delete': '削除',
  'pages.commuteCommit.action.submit': '提出',
  'pages.commuteCommit.action.approve': '承認',
  'pages.commuteCommit.confirm.ok': 'はい',
  'pages.commuteCommit.confirm.cancel': 'いいえ',
  'pages.commuteCommit.delete.title': '交通費削除確認',
  'pages.commuteCommit.delete.confirm': '削除してよろしいでしょうか？',
  'pages.commuteCommit.submit.title': '交通費提出確認',
  'pages.commuteCommit.submit.confirm': '提出してよろしいでしょうか？',
  'pages.commuteCommit.approve.title': '交通費承認確認',
  'pages.commuteCommit.approve.confirm': '承認してよろしいでしょうか？',
  'pages.commuteCommit.header.month': '{year}年{month}月',

  // 休暇申請 (OARequests)
  'pages.oaRequests.title': '休暇申請',
  'pages.oaRequests.column.requestId': '申請',
  'pages.oaRequests.column.status': '状態',
  'pages.oaRequests.column.leavePeriod': '休暇期間',
  'pages.oaRequests.column.reason': '休暇理由',
  'pages.oaRequests.column.rejectReason': '差戻し理由',
  'pages.oaRequests.column.approvalStep': '承認ステップ',
  'pages.oaRequests.column.actions': '操作',
  'pages.oaRequests.status.draft': '下書き',
  'pages.oaRequests.status.submitted': '申請済，承認待ち',
  'pages.oaRequests.status.approved': '承認済',
  'pages.oaRequests.status.rejected': '差戻し',
  'pages.oaRequests.status.cancelled': '取消',
  'pages.oaRequests.action.detail': '詳細',
  'pages.oaRequests.action.edit': '編集',
  'pages.oaRequests.action.submit': '提出',
  'pages.oaRequests.action.cancel': '取消',
  'pages.oaRequests.action.delete': '削除',
  'pages.oaRequests.action.create': '新規休暇申請',
  'pages.oaRequests.action.update': '更新',
  'pages.oaRequests.action.saveDraft': '下書き保存',
  'pages.oaRequests.action.createAndSubmit': '作成して提出',
  'pages.oaRequests.action.cancelBtn': 'キャンセル',
  'pages.oaRequests.action.back': '戻る',
  'pages.oaRequests.modal.editTitle': '休暇申請編集',
  'pages.oaRequests.modal.createTitle': '連続休暇申請作成',
  'pages.oaRequests.drawer.title': '休暇申請詳細',
  'pages.oaRequests.confirm.submit': 'この休暇申請を提出しますか？',
  'pages.oaRequests.confirm.submitMultiple': 'この期間の休暇申請を提出しますか？',
  'pages.oaRequests.confirm.submitDescription':
    '提出後は申請内容を編集できません。修正が必要な場合は、取消後に再申請してください。',
  'pages.oaRequests.confirm.cancel': 'この休暇申請を取り消しますか？',
  'pages.oaRequests.confirm.cancelMultiple': 'この期間の休暇申請を取り消しますか？',
  'pages.oaRequests.confirm.delete': '取消済みの休暇申請を削除しますか？',
  'pages.oaRequests.confirm.deleteMultiple': '取消済みの休暇申請をまとめて削除しますか？',
  'pages.oaRequests.confirm.deleteDescription': '削除後、この申請は一覧に表示されなくなります。',
  'pages.oaRequests.field.leaveDate': '休暇日',
  'pages.oaRequests.field.leavePeriod': '休暇期間',
  'pages.oaRequests.field.leaveType': '休暇種別',
  'pages.oaRequests.field.leaveStartDate': '休暇開始日',
  'pages.oaRequests.field.leaveEndDate': '休暇終了日',
  'pages.oaRequests.field.leaveStartTime': '開始時刻',
  'pages.oaRequests.field.leaveEndTime': '終了時刻',
  'pages.oaRequests.field.reason': '休暇理由',
  'pages.oaRequests.leaveType.fullDay': '終日休暇',
  'pages.oaRequests.leaveType.hourly': '時間休暇',
  'pages.oaRequests.validation.leaveDate': '休暇日を選択してください。',
  'pages.oaRequests.validation.leavePeriod': '休暇期間を選択してください。',
  'pages.oaRequests.confirm.longPeriodTitle': '長期間の休暇申請',
  'pages.oaRequests.confirm.longPeriodDescription':
    '申請期間は{days}日間で、通常の{warningDays}日を超えています。年と期間に誤りがないことを確認してから続行してください。',
  'pages.oaRequests.confirm.longPeriodContinue': '確認して続行',
  'pages.oaRequests.validation.leaveType': '休暇種別を選択してください。',
  'pages.oaRequests.validation.leaveStartDate': '休暇開始日を選択してください。',
  'pages.oaRequests.validation.leaveEndDate': '休暇終了日を選択してください。',
  'pages.oaRequests.validation.leaveDateOrder': '休暇終了日は休暇開始日以降を指定してください。',
  'pages.oaRequests.validation.leaveStartTime': '開始時刻を選択してください。',
  'pages.oaRequests.validation.leaveEndTime': '終了時刻を選択してください。',
  'pages.oaRequests.validation.leaveTimeRange':
    '時刻は08:00〜20:00の範囲で、15分単位で入力してください。',
  'pages.oaRequests.validation.leaveTimeOrder': '終了時刻は開始時刻より後にしてください。',
  'pages.oaRequests.validation.reason': '休暇理由を入力してください。',
  'pages.oaRequests.msg.submitSuccess': '休暇申請を提出しました。',
  'pages.oaRequests.msg.submitMultipleSuccess': '{count}件の休暇申請を提出しました。',
  'pages.oaRequests.msg.submitFailed': '休暇申請の提出に失敗しました。',
  'pages.oaRequests.msg.cancelSuccess': '休暇申請を取消しました。',
  'pages.oaRequests.msg.cancelMultipleSuccess': '{count}件の休暇申請を取消しました。',
  'pages.oaRequests.msg.cancelFailed': '休暇申請の取消に失敗しました。',
  'pages.oaRequests.msg.deleteSuccess': '取消済みの休暇申請を削除しました。',
  'pages.oaRequests.msg.deleteMultipleSuccess': '{count}件の取消済み休暇申請を削除しました。',
  'pages.oaRequests.msg.deleteFailed': '取消済み休暇申請の削除に失敗しました。',
  'pages.oaRequests.msg.updateSuccess': '休暇申請を更新しました。',
  'pages.oaRequests.msg.updateFailed': '休暇申請の更新に失敗しました。',
  'pages.oaRequests.msg.createSuccess': '連続休暇申請を作成しました。',
  'pages.oaRequests.msg.createAndSubmitSuccess': '連続休暇申請を提出しました。',
  'pages.oaRequests.msg.createFailed': '連続休暇申請の保存に失敗しました。',
  'pages.oaRequests.msg.detailFailed': '休暇申請詳細の取得に失敗しました。',
  'pages.oaRequests.detail.requestId': '申請ID',
  'pages.oaRequests.detail.applicant': '申請者',
  'pages.oaRequests.detail.status': '状態',
  'pages.oaRequests.detail.leaveDate': '休暇日',
  'pages.oaRequests.detail.leaveType': '休暇種別',
  'pages.oaRequests.detail.leaveTime': '時間帯',
  'pages.oaRequests.detail.leaveDuration': '休暇時間',
  'pages.oaRequests.detail.approvalStep': '承認ステップ',
  'pages.oaRequests.detail.originalInTime': '原出勤時間',
  'pages.oaRequests.detail.originalBreakTime': '原休憩時間',
  'pages.oaRequests.detail.originalOutTime': '原退勤時間',
  'pages.oaRequests.detail.reason': '休暇理由',
  'pages.oaRequests.detail.rejectReason': '差戻し理由',
  'pages.oaRequests.detail.leaveFlag': '休暇',
  'pages.oaRequests.detail.workFlag': '出勤',
  'pages.oaRequests.itemCount': '{count}件',
  'pages.oaRequests.dayCount': '{count}日',
  'pages.oaRequests.approvalHistory.step': 'STEP',
  'pages.oaRequests.approvalHistory.stepName': 'ステップ名',
  'pages.oaRequests.approvalHistory.approverRole': '承認ロール',
  'pages.oaRequests.approvalHistory.status': '状態',
  'pages.oaRequests.approvalHistory.actionBy': '処理者',
  'pages.oaRequests.approvalHistory.comment': 'コメント',
  'pages.oaRequests.approvalHistory.actionAt': '処理日時',

  // 休暇承認 (OAApprovals)
  'pages.oaApprovals.title': '休暇承認',
  'pages.oaApprovals.tab.pending': '承認待ち',
  'pages.oaApprovals.tab.history': '承認履歴',
  'pages.oaApprovals.historyScope.all': '全て',
  'pages.oaApprovals.historyScope.mine': '自分が処理した分',
  'pages.oaApprovals.column.request': '申請',
  'pages.oaApprovals.column.applicant': '申請者',
  'pages.oaApprovals.column.status': '状態',
  'pages.oaApprovals.column.leavePeriod': '休暇期間',
  'pages.oaApprovals.column.approvalStep': '承認ステップ',
  'pages.oaApprovals.column.reason': '休暇理由',
  'pages.oaApprovals.column.appliedAt': '申請日時',
  'pages.oaApprovals.column.actionAt': '処理日時',
  'pages.oaApprovals.column.actions': '操作',
  'pages.oaApprovals.action.detail': '詳細',
  'pages.oaApprovals.action.approve': '承認',
  'pages.oaApprovals.action.reject': '差戻し',
  'pages.oaApprovals.confirm.approve': 'この休暇申請を承認しますか？',
  'pages.oaApprovals.confirm.approveMultiple': 'この期間の休暇申請を承認しますか？',
  'pages.oaApprovals.confirm.back': '戻る',
  'pages.oaApprovals.reject.title': '差戻し',
  'pages.oaApprovals.reject.reason': '差戻し理由',
  'pages.oaApprovals.reject.validation': '差戻し理由を入力してください。',
  'pages.oaApprovals.msg.loadFailed': '休暇承認一覧の取得に失敗しました。',
  'pages.oaApprovals.msg.detailFailed': '休暇申請詳細の取得に失敗しました。',
  'pages.oaApprovals.msg.approveSuccess': '休暇申請を承認しました。',
  'pages.oaApprovals.msg.approveMultipleSuccess': '{count}件の休暇申請を承認しました。',
  'pages.oaApprovals.msg.approveFailed': '休暇申請の承認に失敗しました。',
  'pages.oaApprovals.msg.rejectSuccess': '休暇申請を差戻しました。',
  'pages.oaApprovals.msg.rejectMultipleSuccess': '{count}件の休暇申請を差戻しました。',
  'pages.oaApprovals.msg.rejectFailed': '休暇申請の差戻しに失敗しました。',
  'pages.oaApprovals.drawer.title': '休暇申請詳細',
  'pages.oaApprovals.summary.leaveRequest': '休暇申請 {label}',
  'pages.oaApprovals.summary.requestId': '申請ID: {ids}',
  'pages.oaApprovals.summary.periodMultiple': '{count}日分',
  'pages.oaApprovals.summary.periodSingle': '1日分',
  'pages.oaApprovals.detail.requestId': '申請ID',
  'pages.oaApprovals.detail.applicant': '申請者',
  'pages.oaApprovals.detail.status': '状態',
  'pages.oaApprovals.detail.leaveDate': '休暇日',
  'pages.oaApprovals.detail.originalInTime': '原出勤時間',
  'pages.oaApprovals.detail.originalBreakTime': '原休憩時間',
  'pages.oaApprovals.detail.originalOutTime': '原退勤時間',
  'pages.oaApprovals.detail.reason': '休暇理由',
  'pages.oaApprovals.detail.rejectReason': '差戻し理由',

  // 休暇承認フロー (OAWorkflows)
  'pages.oaWorkflows.title': '休暇承認フロー',
  'pages.oaWorkflows.column.workflowName': 'フロー名',
  'pages.oaWorkflows.column.active': '有効',
  'pages.oaWorkflows.column.steps': '承認ステップ',
  'pages.oaWorkflows.column.actions': '操作',
  'pages.oaWorkflows.action.edit': '編集',
  'pages.oaWorkflows.modal.editTitle': '休暇承認フロー編集',
  'pages.oaWorkflows.field.workflowName': 'フロー名',
  'pages.oaWorkflows.field.active': '有効',
  'pages.oaWorkflows.field.steps': '承認ステップ',
  'pages.oaWorkflows.field.stepNo': 'ステップ番号',
  'pages.oaWorkflows.field.stepName': 'ステップ名',
  'pages.oaWorkflows.field.approverRole': '承認ロール',
  'pages.oaWorkflows.step.stepNo': 'ステップ番号',
  'pages.oaWorkflows.step.stepName': 'ステップ名',
  'pages.oaWorkflows.step.approverRole': '承認ロール',
  'pages.oaWorkflows.validation.workflowName': 'フロー名を入力してください。',
  'pages.oaWorkflows.validation.stepNo': 'ステップ番号を入力してください。',
  'pages.oaWorkflows.validation.stepName': 'ステップ名を入力してください。',
  'pages.oaWorkflows.validation.approverRole': '承認ロールを選択してください。',
  'pages.oaWorkflows.validation.noticeEmails': '通知先メールアドレスの形式が正しくありません。',
  'pages.oaWorkflows.step.noticeEmails': '追加通知先メール',
  'pages.oaWorkflows.step.noticeEmailsPlaceholder': '通知先メールを入力して Enter',
  'pages.oaWorkflows.step.noticeEmailCount': '追加通知: {count}件',
  'pages.oaWorkflows.action.addStep': 'ステップ追加',
  'pages.oaWorkflows.action.delete': '削除',
  'pages.oaWorkflows.action.deleteStep': '削除',
  'pages.oaWorkflows.msg.loadFailed': '休暇承認フローの取得に失敗しました。',
  'pages.oaWorkflows.msg.updateSuccess': '休暇承認フローを更新しました。',
  'pages.oaWorkflows.msg.updateFailed': '休暇承認フローの更新に失敗しました。',

  // 共通
  'pages.attendance.yes': 'はい',
  'pages.attendance.no': 'いいえ',
  'pages.attendance.accountId': '社員ID',
  'pages.attendance.employeeName': '社員名',
  'pages.attendance.search.button': '検索',
  'pages.attendance.search.placeholder': '社員ID / アカウント名 / 社員名 / 役割 / ステータスで検索',
  'pages.attendance.search.result': '検索結果',
  'pages.attendance.search.countUnit': '件',
  'pages.accounting.salaryManagement.title': '給与管理',
  'pages.accounting.salaryManagement.search.button': '検索',
  'pages.accounting.salaryManagement.search.placeholder': '社員ID / 社員名 / アカウントで検索',
  'pages.accounting.salaryManagement.search.result': '検索結果',
  'pages.accounting.salaryManagement.search.countUnit': '件',
  'pages.accounting.salaryManagement.summary.companyActualIncome': '会社実収入合計',
  'pages.accounting.salaryManagement.summary.scope':
    '対象月の在籍期間に基づく会社実収入合計。現在退職・停用でも過去の在籍月は含み、検索・分類フィルターには連動しません。在籍期間不明や期間外の精算は要確認です。',
  'pages.accounting.salaryManagement.summary.pendingHelp':
    '計算できない対象者がいる場合は、部分合計を表示せず「要確認」とします。',
  'pages.accounting.salaryManagement.summary.pendingCount': '要確認人数',
  'pages.accounting.salaryManagement.reload': '再読込',
  'pages.accounting.salaryManagement.filter.contractType': '契約形態',
  'pages.accounting.salaryManagement.filter.targetMonth': '対象年月',
  'pages.accounting.salaryManagement.contractType.trainee': '就職指向',
  'pages.accounting.salaryManagement.contractType.internal': '研修社員（内定者）',
  'pages.accounting.salaryManagement.contractType.contract': '契約社員',
  'pages.accounting.salaryManagement.contractType.employee': '契約・正社員',
  'pages.accounting.salaryManagement.contractType.regular': '正社員',
  'pages.accounting.salaryManagement.contractType.bp': 'BP社員',
  'pages.accounting.salaryManagement.contractType.resigned': '退職済み',
  'pages.accounting.salaryManagement.accountStatus.active': '正在使用',
  'pages.accounting.salaryManagement.accountStatus.disabled': '停用',
  'pages.accounting.salaryManagement.status.active': '在職中',
  'pages.accounting.salaryManagement.status.undefined': '未定',
  'pages.accounting.salaryManagement.status.contractFinished': '契約期間終了',
  'pages.accounting.salaryManagement.status.bpFinished': 'BP終了',
  'pages.accounting.salaryManagement.status.resigned': '退職済み',
  'pages.accounting.salaryManagement.column.employeeId': '社員ID',
  'pages.accounting.salaryManagement.column.employeeName': '社員名',
  'pages.accounting.salaryManagement.column.accountStatus': 'アカウント状態',
  'pages.accounting.salaryManagement.column.contractType': '契約形態',
  'pages.accounting.salaryManagement.column.status': '状態',
  'pages.accounting.salaryManagement.column.currentSalary': '基本給',
  'pages.accounting.salaryManagement.column.specialAllowance': '特別手当',
  'pages.accounting.salaryManagement.column.employerBurden': '会社負担見込額',
  'pages.accounting.salaryManagement.column.totalCompanyCost': '会社総コスト',
  'pages.accounting.salaryManagement.column.projectRevenue': '案件収入',
  'pages.accounting.salaryManagement.column.companyActualIncome': '会社実収入',
  'pages.accounting.salaryManagement.projectRevenueHelp':
    '対象月の案件収入（見込・税抜）。請求済は明細金額、未請求は案件単価。',
  'pages.accounting.salaryManagement.companyActualIncomeHelp':
    '会社実収入 = 案件収入 − 会社総コスト。',
  'pages.accounting.salaryManagement.column.lastRaiseAmount': '最新昇給額',
  'pages.accounting.salaryManagement.column.lastRaiseDate': '最新昇給日',
  'pages.accounting.salaryManagement.column.nextRaisePlannedDate': '次回昇給予定日',
  'pages.accounting.salaryManagement.column.action': '操作',
  'pages.accounting.salaryManagement.modal.editTitle': '給与情報編集',
  'pages.accounting.salaryManagement.modal.historyTitle': '昇給履歴',
  'pages.accounting.salaryManagement.modal.historyTitleWithName': '{name} の昇給履歴',
  'pages.accounting.salaryManagement.label.beforeSaveCurrentSalary': '保存前の基本給',
  'pages.accounting.salaryManagement.field.currentSalary': '基本給',
  'pages.accounting.salaryManagement.field.specialAllowance': '特別手当',
  'pages.accounting.salaryManagement.field.specialAllowance.extra':
    '{month}分の一時的な手当です。雇用保険・労災保険と会社総コストに反映します。',
  'pages.accounting.salaryManagement.insuranceSettings.title': '保険計算設定',
  'pages.accounting.salaryManagement.field.socialInsuranceApplicable': '社会保険',
  'pages.accounting.salaryManagement.field.employmentInsuranceApplicable': '雇用保険',
  'pages.accounting.salaryManagement.field.careInsuranceMode': '介護保険判定',
  'pages.accounting.salaryManagement.option.applicable': '対象',
  'pages.accounting.salaryManagement.option.notApplicable': '対象外',
  'pages.accounting.salaryManagement.option.careAuto': '生年月日から自動',
  'pages.accounting.salaryManagement.option.careOn': '対象',
  'pages.accounting.salaryManagement.option.careOff': '対象外',
  'pages.accounting.salaryManagement.field.healthStandardOverride':
    '健康保険標準報酬月額（手動設定）',
  'pages.accounting.salaryManagement.field.pensionStandardOverride':
    '厚生年金標準報酬月額（手動設定）',
  'pages.accounting.salaryManagement.field.standardOverride.extra':
    '未入力の場合は基本給から等級を自動算出します。届出済みの標準報酬月額がある場合のみ入力してください。',
  'pages.accounting.salaryManagement.field.lastRaiseDate': '最新昇給日',
  'pages.accounting.salaryManagement.field.lastRaiseAmount': '最新昇給額',
  'pages.accounting.salaryManagement.field.nextRaisePlannedDate': '次回昇給予定日',
  'pages.accounting.salaryManagement.helper.syncHistory':
    '最新昇給日と最新昇給額を保存すると、履歴の最新1件にも同じ内容を反映します。',
  'pages.accounting.salaryManagement.history.column.raiseDate': '昇給日',
  'pages.accounting.salaryManagement.history.column.beforeCurrentSalary': '昇給前給与',
  'pages.accounting.salaryManagement.history.column.afterCurrentSalary': '昇給後給与',
  'pages.accounting.salaryManagement.history.column.raiseAmount': '昇給額',
  'pages.accounting.salaryManagement.history.column.nextRaisePlannedDate': '次回昇給予定日',
  'pages.accounting.salaryManagement.history.column.createdAt': '登録日時',
  'pages.accounting.salaryManagement.history.column.targetMonth': '対象年月',
  'pages.accounting.salaryManagement.history.column.updatedAt': '更新日時',
  'pages.accounting.salaryManagement.history.tab.salary': '昇給履歴',
  'pages.accounting.salaryManagement.history.tab.specialAllowance': '特別手当履歴',
  'pages.accounting.salaryManagement.history.empty': '履歴がありません。',
  'pages.accounting.salaryManagement.history.deleteConfirm': 'この履歴を削除しますか？',
  'pages.accounting.salaryManagement.action.edit': '編集',
  'pages.accounting.salaryManagement.action.history': '履歴',
  'pages.accounting.salaryManagement.action.save': '保存',
  'pages.accounting.salaryManagement.action.cancel': 'キャンセル',
  'pages.accounting.salaryManagement.action.delete': '削除',
  'pages.accounting.salaryManagement.msg.loadFailed': '給与管理データの取得に失敗しました。',
  'pages.accounting.salaryManagement.msg.filterFailed': '給与管理データの絞り込みに失敗しました。',
  'pages.accounting.salaryManagement.msg.saveSuccess': '給与情報を保存しました。',
  'pages.accounting.salaryManagement.msg.saveFailed': '給与情報の保存に失敗しました。',
  'pages.accounting.salaryManagement.msg.historyLoadFailed': '昇給履歴の取得に失敗しました。',
  'pages.accounting.salaryManagement.msg.specialAllowanceHistoryLoadFailed':
    '特別手当履歴の取得に失敗しました。',
  'pages.accounting.salaryManagement.msg.historyDeleteSuccess': '昇給履歴を削除しました。',
  'pages.accounting.salaryManagement.msg.historyDeleteFailed': '昇給履歴の削除に失敗しました。',
  'pages.accounting.salaryManagement.guide.title':
    '給与管理では、基本給・月別特別手当・会社負担見込額をまとめて確認できます。',
  'pages.accounting.salaryManagement.guide.line1':
    '対象年月を選び、「編集」から基本給・特別手当・保険計算設定を更新します。',
  'pages.accounting.salaryManagement.guide.line2':
    '最新昇給日と最新昇給額を保存すると、昇給履歴にも反映されます。誤登録した履歴は「履歴」から削除できます。',
  'pages.accounting.salaryManagement.modal.guide.title':
    '保存前に、更新したい内容を確認してください。',
  'pages.accounting.salaryManagement.modal.guide.line1':
    '基本給だけを修正したい場合は、基本給のみ更新して保存してください。',
  'pages.accounting.salaryManagement.modal.guide.line2':
    '最新昇給日と最新昇給額を入力すると、昇給履歴にも同じ内容を反映します。',
  'pages.accounting.salaryManagement.modal.guide.line3':
    '誤って登録した昇給履歴は、保存後に「履歴」画面から削除できます。',
  'pages.accounting.salaryManagement.field.currentSalary.extra':
    '現在の基本給を入力します。昇給登録ではなく単純修正の場合もここを更新してください。',
  'pages.accounting.salaryManagement.field.lastRaiseDate.extra':
    '直近の昇給日を登録したい場合に入力します。履歴に反映されます。',
  'pages.accounting.salaryManagement.field.lastRaiseAmount.extra':
    '直近の昇給額を入力します。最新昇給日とあわせて保存すると履歴に反映されます。',
  'pages.accounting.salaryManagement.field.nextRaisePlannedDate.extra':
    '次回昇給の予定が決まっている場合に入力します。',
  'pages.accounting.salaryManagement.history.guide.line1':
    '最新の履歴が上に表示されます。誤登録した履歴は削除できます。',
  'pages.accounting.salaryManagement.history.guide.line2':
    '履歴を削除すると、一覧の最新給与情報も残っている履歴に合わせて再計算されます。',
  'pages.accounting.salaryManagement.cost.outsideEmployment': '対象月は在籍期間外',
  'pages.accounting.salaryManagement.cost.missingBaseSalary': '基本給未登録',
  'pages.accounting.salaryManagement.cost.reviewRequired': '要確認',
  'pages.accounting.salaryManagement.cost.departureDateRequired': '退社日未登録',
  'pages.accounting.salaryManagement.cost.departureDateRequiredHelp':
    '停用アカウントの退社日が未登録のため、対象月の在籍とコストを確認してください。0円や10万円固定では代用しません。',
  'pages.accounting.salaryManagement.cost.settlementReview': '精算要確認',
  'pages.accounting.salaryManagement.cost.settlementReviewHelp':
    '在籍期間外の案件収入または特別手当があります。対象月の精算を確認してください。現在給与や10万円固定は自動計上しません。',
  'pages.accounting.salaryManagement.cost.rateNotConfigured': '料率未設定',
  'pages.accounting.salaryManagement.cost.breakdownTitle': '会社負担見込額の内訳',
  'pages.accounting.salaryManagement.cost.healthStandard': '健康保険標準報酬月額',
  'pages.accounting.salaryManagement.cost.pensionStandard': '厚生年金標準報酬月額',
  'pages.accounting.salaryManagement.cost.health': '健康保険',
  'pages.accounting.salaryManagement.cost.pension': '厚生年金',
  'pages.accounting.salaryManagement.cost.employment': '雇用保険',
  'pages.accounting.salaryManagement.cost.workersComp': '労災保険',
  'pages.accounting.salaryManagement.cost.childRelated': '子育て関連負担',
  'pages.accounting.salaryManagement.cost.childRelatedDetail':
    '子ども・子育て支援金 {support} / 子ども・子育て拠出金 {contribution}',
  'pages.accounting.salaryManagement.cost.care': '介護保険',
  'pages.interviewList.filter.category': '面接状況',
  'pages.interviewList.filter.scheduled': '面接予定あり',
  'pages.interviewList.filter.pending': '結果保留',
  'pages.interviewList.filter.pass': '合格',
  'pages.interviewList.filter.fail': '不合格',
  'pages.interviewList.column.sequenceNo': 'No.',
  'pages.interviewList.column.interviewScheduled': '面接予定',
  'pages.interviewList.column.totalScore': '総合点',
  'pages.interviewList.column.interviewResult': '結果',
  'pages.interviewList.column.attendanceStatus': '入社状況',
  'pages.interviewList.column.pic': '担当者',
  'pages.interviewList.chart.title': '応募日ベース月別人数',
  'pages.interviewList.chart.subtitle': '現在の検索・絞り込み条件を反映',
  'pages.interviewList.chart.month': '応募月',
  'pages.interviewList.chart.count': '人数',
  'pages.interviewList.chart.countUnit': '人',
  'pages.interviewList.chart.empty': '表示できる応募日データがありません。',
  'pages.interviewList.title': '面接情報一覧',
  'pages.interviewList.create': '新規登録',
  'pages.interviewList.reload': '再読込',
  'pages.interviewList.search.button': '検索',
  'pages.interviewList.search.placeholder': '候補者名 / 応募職種 / 応募経路 / PICで検索',
  'pages.interviewList.search.result': '検索結果',
  'pages.interviewList.search.countUnit': '件',
  'pages.interviewList.filter.all': '全て',
  'pages.interviewList.filter.applicationYear': '応募年',
  'pages.interviewList.filter.applicationMonth': '応募月',
  'pages.interviewList.filter.monthSuffix': '月',
  'pages.interviewList.filter.status': '選考&面接&テスト状況',
  'pages.interviewList.filter.appliedPosition': '応募職種',
  'pages.interviewList.filter.sourceChannel': '応募経路',
  'pages.interviewList.filter.position.it': 'it技術職',
  'pages.interviewList.filter.position.sales': '営業職',
  'pages.interviewList.filter.position.office': '事務職',
  'pages.interviewList.filter.source.ijob': 'ijob',
  'pages.interviewList.filter.source.referral': '紹介',
  'pages.interviewList.filter.source.xiaohongshu': '小紅書',
  'pages.interviewList.filter.source.other': 'その他',
  'pages.interviewList.filter.status.screeningPass': '選考合格',
  'pages.interviewList.filter.status.screeningFail': '選考見送り',
  'pages.interviewList.filter.status.screeningPending': '選考保留',
  'pages.interviewList.filter.status.interviewScheduled': '面接予定',
  'pages.interviewList.filter.status.firstPass': '一面合格',
  'pages.interviewList.filter.status.firstFail': '一面見送り',
  'pages.interviewList.filter.status.firstPending': '一面保留',
  'pages.interviewList.filter.status.testInProgress': 'テスト実施中',
  'pages.interviewList.filter.status.testPass': 'テスト合格',
  'pages.interviewList.filter.status.testFail': 'テスト見送り',
  'pages.interviewList.column.listNo': 'No.',
  'pages.interviewList.column.candidateName': '候補者名',
  'pages.interviewList.column.applicationDate': '応募日',
  'pages.interviewList.column.appliedPosition': '応募職種',
  'pages.interviewList.column.sourceChannel': '応募経路',
  'pages.interviewList.column.screeningScore': '結果点数（選考）',
  'pages.interviewList.column.screeningResult': '選考結果',
  'pages.interviewList.column.interviewStatus': '面接ステータス',
  'pages.interviewList.column.interviewDate': '面接日',
  'pages.interviewList.column.interviewForm': '面接形式',
  'pages.interviewList.column.firstInterviewScore': '結果点数（一面）',
  'pages.interviewList.column.firstInterviewResult': '面接結果（一面）',
  'pages.interviewList.column.action': '操作',
  'pages.interviewList.modal.createTitle': '面接情報新規登録',
  'pages.interviewList.modal.editTitle': '面接情報編集',
  'pages.interviewList.section.basic': '基本情報',
  'pages.interviewList.section.screening': '初期選考',
  'pages.interviewList.section.interview': '面接情報',
  'pages.interviewList.section.followup': '結果通知・フォロー',
  'pages.interviewList.simple.basic': '基本情報',
  'pages.interviewList.simple.gender': '性別',
  'pages.interviewList.simple.birthday': '生年月日',
  'pages.interviewList.simple.age': '{age}歳',
  'pages.interviewList.simple.country': '国籍',
  'pages.interviewList.simple.region': '省份／地区',
  'pages.interviewList.simple.visa': '在留情報',
  'pages.interviewList.simple.visaExpiry': '在留有効期限',
  'pages.interviewList.simple.remainingDays': '残り {days} 日',
  'pages.interviewList.simple.screening': '履歴書選考',
  'pages.interviewList.simple.screeningResult': '選考結果',
  'pages.interviewList.simple.screeningRemarks': '選考備考',
  'pages.interviewList.simple.first': '一次面接',
  'pages.interviewList.simple.interviewer': '面接担当',
  'pages.interviewList.simple.interviewStatus': '実施状況',
  'pages.interviewList.simple.skill': '経験・スキル',
  'pages.interviewList.simple.communication': 'コミュニケーション力',
  'pages.interviewList.simple.thinking': '主体性・思考力',
  'pages.interviewList.simple.personality': '人物適性',
  'pages.interviewList.simple.motivation': '志望動機',
  'pages.interviewList.simple.japanese': '日本語能力',
  'pages.interviewList.simple.scoreGuide': '採点基準',
  'pages.interviewList.simple.evaluation': '面接評価',
  'pages.interviewList.simple.rollback': '履歴書選考へ戻す（一面情報をクリア）',
  'pages.interviewList.simple.training': '研修',
  'pages.interviewList.simple.trainingHint':
    '人事部は開始日のみ登録します。期間・テスト・評価は開発部が管理します。',
  'pages.interviewList.simple.trainingStart': '研修開始日',
  'pages.interviewList.simple.developmentManaged':
    '開発部で管理中です。開始日の変更は進捗カレンダーで行ってください。',
  'pages.interviewList.simple.followup': '開発部フォロー（参照）',
  'pages.interviewList.simple.trainingEnd': '研修終了日',
  'pages.interviewList.simple.trainingStatus': '研修状況',
  'pages.interviewList.simple.testDate': 'テスト日',
  'pages.interviewList.simple.testResult': 'テスト結果',
  'pages.interviewList.simple.trainingRemarks': '研修備考',
  'pages.interviewList.simple.accountStatus': 'アカウント状態',
  'pages.interviewList.simple.active': '使用中',
  'pages.interviewList.simple.inactive': '停止',
  'pages.interviewList.simple.accountNotCreated': '未生成',
  'pages.interviewList.simple.pendingTrainings': '人事登録・手配待ち研修',
  'pages.interviewList.simple.arrangeTraining': '手配',
  'pages.interviewList.simple.waitingAccount': '人事のアカウント生成待ち',
  'pages.interviewList.simple.completePeriod': '開始日と終了日を正しく入力してください。',
  'pages.interviewList.simple.status.not_started': '未実施',
  'pages.interviewList.simple.status.completed': '実施済',
  'pages.interviewList.simple.status.declined': '辞退',
  'pages.interviewList.simple.status.absent': '無断欠席',
  'pages.interviewList.field.sequenceNo': '連番',
  'pages.interviewList.field.applicationDate': '応募日',
  'pages.interviewList.field.candidateName': '候補者名',
  'pages.interviewList.field.appliedPosition': '応募職種',
  'pages.interviewList.field.sourceChannel': '応募経路',
  'pages.interviewList.field.pic': 'PIC',
  'pages.interviewList.field.skillMatchLevel': 'スキル適合度',
  'pages.interviewList.field.experienceAssessment': '経験評価',
  'pages.interviewList.field.japaneseAssessment': '日本語評価',
  'pages.interviewList.field.visaType': 'VISA種別',
  'pages.interviewList.field.interviewScheduled': '面接予定',
  'pages.interviewList.field.initialScreeningRemarks': '初期選考メモ',
  'pages.interviewList.field.attendanceStatus': '入社状況',
  'pages.interviewList.field.interviewDate': '面接日',
  'pages.interviewList.field.interviewForm': '面接形式',
  'pages.interviewList.field.skillEvaluation': 'スキル評価',
  'pages.interviewList.field.motivationEvaluation': '動機評価',
  'pages.interviewList.field.japaneseEvaluation': '日本語評価',
  'pages.interviewList.field.attitudeEvaluation': '態度評価',
  'pages.interviewList.field.totalScore': '総合点',
  'pages.interviewList.field.interviewResult': '面接結果',
  'pages.interviewList.field.interviewRemarks': '面接メモ',
  'pages.interviewList.field.resultNotifyDate': '結果通知日',
  'pages.interviewList.field.followupRemarks': 'フォローメモ',
  'pages.interviewList.option.autoSequence': '新規登録時に自動採番',
  'pages.interviewList.option.unscheduled': '未設定',
  'pages.interviewList.option.scheduled': '予定あり',
  'pages.interviewList.option.online': 'online',
  'pages.interviewList.option.offline': 'offline',
  'pages.interviewList.option.pending': '保留',
  'pages.interviewList.option.pass': '合格',
  'pages.interviewList.option.fail': '見送り',
  'pages.interviewList.action.edit': '編集',
  'pages.interviewList.action.delete': '削除',
  'pages.interviewList.action.save': '保存',
  'pages.interviewList.action.cancel': 'キャンセル',
  'pages.interviewList.confirm.delete': 'この面接情報を削除しますか？',
  'pages.interviewList.validation.candidateName': '候補者名を入力してください。',
  'pages.interviewList.msg.loadFailed': '面接情報の読み込みに失敗しました。',
  'pages.interviewList.msg.createSuccess': '面接情報を登録しました。',
  'pages.interviewList.msg.updateSuccess': '面接情報を更新しました。',
  'pages.interviewList.msg.saveFailed': '面接情報の保存に失敗しました。',
  'pages.interviewList.msg.deleteSuccess': '面接情報を削除しました。',
  'pages.interviewList.msg.deleteFailed': '面接情報の削除に失敗しました。',
  'pages.interviewList.msg.rollbackToScreeningSuccess': '面接情報を履歴書選考へ戻しました。',
  'pages.interviewList.msg.rollbackToScreeningFailed': '面接情報を履歴書選考へ戻せませんでした。',

  'pages.interviewList.calendar.title': '面接カレンダー',
  'pages.interviewList.calendar.firstInterview': '一次面接',
  'pages.interviewList.calendar.testPeriod': 'テスト期間',
  'pages.interviewList.calendar.noInterviews': '面接の予定はありません',
  'pages.interviewList.calendar.noUpcoming': '今後の予定はありません',
  'pages.interviewList.calendar.countUnit': '件',
  'pages.interviewList.calendar.more': '件',
  'pages.interviewList.calendar.upcoming': '今後の予定',
  'pages.interviewList.calendar.button': '面接カレンダー',
  // Account Management Page
  'pages.accountManagement.accountId': 'アカウントID',
  'pages.accountManagement.email': 'メール',
  'pages.accountManagement.email.placeholder': 'メールアドレスを入力してください',
  'pages.accountManagement.emailInvalid': '有効なメールアドレスを入力してください。',
  'pages.accountManagement.emailIsVerified': 'メール認証',
  'pages.accountManagement.phoneNumber': '携帯番号',
  'pages.accountManagement.phoneNumber.placeholder': '例：090-1234-5678',
  'pages.accountManagement.phoneNumberInvalid': '有効な電話番号を入力してください。',
  'pages.accountManagement.phoneIsVerified': '携帯認証',
  'pages.accountManagement.operation': '操作',
  'pages.accountManagement.update': '編集',
  'pages.accountManagement.update.process': 'アカウント更新中...',
  'pages.accountManagement.update.done': 'アカウントを更新しました。',
  'pages.accountManagement.update.failed': 'アカウントの更新に失敗しました。',
  'pages.accountManagement.accountName': 'アカウント名',
  'pages.accountManagement.accountName.placeholder': 'アカウント名を入力してください',
  'pages.accountManagement.account.required': 'アカウント名を入力してください。',
  'pages.accountManagement.account.accountNameLength':
    'アカウント名は6〜18文字で入力してください。',
  'pages.accountManagement.account.accountNameInvalid':
    'アカウント名は英字で始まる半角英数字で入力してください。',
  'pages.accountManagement.password': 'パスワード',
  'pages.accountManagement.password.placeholder': 'パスワードを入力してください',
  'pages.accountManagement.password.required': 'パスワードを入力してください。',
  'pages.accountManagement.password.passwordLength': 'パスワードは6〜18文字で入力してください。',
  'pages.accountManagement.password.passwordInvalid': 'パスワードは半角英数字のみ使用できます。',
  'pages.accountManagement.passwordReset': 'パスワードリセット',
  'pages.accountManagement.passwordReset.process': 'パスワードリセット中...',
  'pages.accountManagement.passwordReset.done': 'パスワードをリセットしました。',
  'pages.accountManagement.passwordReset.doneWithNotice':
    'パスワードを123456にリセットしました。ユーザーに変更を案内してください。',
  'pages.accountManagement.passwordReset.failed': 'パスワードリセットに失敗しました。',
  'pages.accountManagement.passwordReset.confirmTitle': 'パスワードをリセットしますか？',
  'pages.accountManagement.passwordReset.confirmDescription':
    'パスワードを初期値123456にリセットします。',
  'pages.accountManagement.delete': '削除',
  'pages.accountManagement.delete.process': 'アカウント削除中...',
  'pages.accountManagement.delete.done': 'アカウントを削除しました。',
  'pages.accountManagement.delete.failed': 'アカウントの削除に失敗しました。',
  'pages.accountManagement.delete.confirmTitle': 'アカウントを削除しますか？',
  'pages.accountManagement.delete.currentAccountDenied': 'ログイン中のアカウントは削除できません。',
  'pages.accountManagement.delete.batchCurrentSkipped':
    'ログイン中のアカウントは削除対象から除外しました。',
  'pages.accountManagement.delete.batchConfirmTitle': '選択したアカウントを削除しますか？',
  'pages.accountManagement.delete.batchConfirmCount': '削除対象',
  'pages.accountManagement.delete.batchConfirmMore': 'ほか',
  'pages.accountManagement.searchList': 'アカウント一覧',
  'pages.accountManagement.serachList': 'アカウント一覧',
  'pages.accountManagement.create': 'アカウント新規作成',
  'pages.accountManagement.create.process': 'アカウント作成中...',
  'pages.accountManagement.create.done': 'アカウントを作成しました。',
  'pages.accountManagement.create.failed': 'アカウントの作成に失敗しました。',
  'pages.accountManagement.selected': 'アカウント選択中',
  'pages.accountManagement.selectedDelete': '選択したアカウントを削除',
  'pages.accountManagement.roleSet': 'ロール編集',
  'pages.accountManagement.roleSet.view': 'ロール読み込み中...',
  'pages.accountManagement.roleSet.title': 'アカウントロール編集',
  'pages.accountManagement.roleSet.roles': 'ロール選択',
  'pages.accountManagement.roleSet.selectedCount': '選択中ロール',
  'pages.accountManagement.roleSet.empty': '設定可能なロールがありません。',
  'pages.accountManagement.roleSet.emptyConfirmTitle': 'ロール未設定で保存しますか？',
  'pages.accountManagement.roleSet.emptyConfirmContent':
    'ロールをすべて外すと、このアカウントは利用できる画面がなくなる可能性があります。',
  'pages.accountManagement.roleSetting.process': 'ロール情報を更新中...',
  'pages.accountManagement.roleSetting.done': 'ロール情報を更新しました。',
  'pages.accountManagement.roleSetting.failed': 'ロール情報の更新に失敗しました。',
  'pages.accountManagement.verified': '認証済み',
  'pages.accountManagement.unverified': '未認証',
  'pages.accountManagement.countUnit': '件',
  'pages.accountManagement.action.save': '保存',
  'pages.accountManagement.action.cancel': 'キャンセル',
  'pages.accountManagement.modal.createTitle': 'アカウント新規作成',
  'pages.accountManagement.modal.editTitle': 'アカウント編集',
  'pages.accountManagement.modal.accountNameReadonly': 'アカウント名は作成後に変更できません。',
  'pages.accountManagement.search.button': '検索',
  'pages.accountManagement.search.placeholder':
    'アカウントID / アカウント名 / メール / 携帯番号で検索',
  'pages.accountManagement.search.result': '検索結果',
  'pages.accountManagement.reload': '再読込',
  'pages.accountManagement.load.failed': 'アカウント一覧の取得に失敗しました。',
  'pages.accountManagement.filter.status': '状態',
  'pages.accountManagement.filter.all': '全部',
  'pages.accountManagement.filter.emailUnverified': 'メール未認証',
  'pages.accountManagement.filter.phoneUnverified': '携帯未認証',
  'pages.accountManagement.accountStatus.title': 'アカウント状態',
  'pages.accountManagement.accountStatus.active': '使用中',
  'pages.accountManagement.accountStatus.disabled': '停止中',

  // 固定資産管理
  'pages.fixedAssets.title': '固定資産一覧',
  'pages.fixedAssets.countUnit': '件',
  'pages.fixedAssets.group.sameName': '同名資産',
  'pages.fixedAssets.group.assetCount': '{count}件',
  'pages.fixedAssets.group.mixed': '複数',
  'pages.fixedAssets.group.expandForDetail': '展開して確認',
  'pages.fixedAssets.group.expandForAction': '展開して操作',
  'pages.fixedAssets.group.countSummary': '{groups}グループ / {assets}件',
  'pages.fixedAssets.filter.all': 'すべて',
  'pages.fixedAssets.filter.category': '資産カテゴリ',
  'pages.fixedAssets.filter.status': '資産ステータス',
  'pages.fixedAssets.filter.location': '所在地',
  'pages.fixedAssets.filter.clear': '条件クリア',
  'pages.fixedAssets.search.placeholder': '資産名 / 資産番号 / ブランド / 備考で検索',
  'pages.fixedAssets.search.button': '検索',
  'pages.fixedAssets.action.create': '新規登録',
  'pages.fixedAssets.action.edit': '編集',
  'pages.fixedAssets.action.copy': 'コピー',
  'pages.fixedAssets.action.delete': '削除',
  'pages.fixedAssets.action.save': '保存',
  'pages.fixedAssets.action.bulkSave': '一括保存',
  'pages.fixedAssets.action.copyAdd': 'コピー追加',
  'pages.fixedAssets.action.cancel': '取消',
  'pages.fixedAssets.action.reload': '再読込',
  'pages.fixedAssets.action.add': '追加',
  'pages.fixedAssets.action.update': '更新',
  'pages.fixedAssets.action.categoryManagement': 'カテゴリ管理',
  'pages.fixedAssets.action.addPart': '部品を追加',
  'pages.fixedAssets.action.addUsageHistory': '使用履歴を追加',
  'pages.fixedAssets.column.assetNumber': '資産番号',
  'pages.fixedAssets.column.assetName': '資産名',
  'pages.fixedAssets.column.category': 'カテゴリ',
  'pages.fixedAssets.column.brandOs': 'ブランド / OS',
  'pages.fixedAssets.column.purchaseAmount': '購入金額',
  'pages.fixedAssets.column.purchaseDate': '購入日',
  'pages.fixedAssets.column.useDuration': '利用時間',
  'pages.fixedAssets.column.location': '所在地',
  'pages.fixedAssets.column.currentUser': '使用者',
  'pages.fixedAssets.column.stockInDate': '入庫日',
  'pages.fixedAssets.column.brand': 'ブランド',
  'pages.fixedAssets.column.status': 'ステータス',
  'pages.fixedAssets.column.remarks': '備考',
  'pages.fixedAssets.column.action': '操作',
  'pages.fixedAssets.modal.createTitle': '固定資産新規登録',
  'pages.fixedAssets.modal.editTitle': '固定資産編集',
  'pages.fixedAssets.modal.copyTitle': '固定資産コピー追加',
  'pages.fixedAssets.section.basic': '基本情報',
  'pages.fixedAssets.section.parts': '部品',
  'pages.fixedAssets.section.assetState': '資産状態',
  'pages.fixedAssets.section.usageHistory': '使用履歴',
  'pages.fixedAssets.section.remarks': '備考',
  'pages.fixedAssets.field.assetName': '資産名',
  'pages.fixedAssets.field.majorCategory': '大分類',
  'pages.fixedAssets.field.subCategory': '小分類',
  'pages.fixedAssets.field.brand': 'ブランド',
  'pages.fixedAssets.field.purchaseAmount': '購入金額',
  'pages.fixedAssets.field.purchaseDate': '購入日',
  'pages.fixedAssets.field.location': '所在地',
  'pages.fixedAssets.field.assetStatus': '資産ステータス',
  'pages.fixedAssets.field.partName': '部品名',
  'pages.fixedAssets.field.quantity': '数量',
  'pages.fixedAssets.field.registrationQuantity': '登録数量',
  'pages.fixedAssets.field.temporaryNumber': '仮番号',
  'pages.fixedAssets.field.userName': '使用者',
  'pages.fixedAssets.field.useStartDate': '使用開始日',
  'pages.fixedAssets.field.useEndDate': '使用終了日',
  'pages.fixedAssets.field.stockInDate': '入庫日',
  'pages.fixedAssets.field.usePeriod': '使用期間',
  'pages.fixedAssets.placeholder.assetName': '例：MacBook Pro 14インチ',
  'pages.fixedAssets.placeholder.majorCategory': '大分類を選択',
  'pages.fixedAssets.placeholder.subCategory': '小分類を選択',
  'pages.fixedAssets.placeholder.noSubCategory': '小分類なし',
  'pages.fixedAssets.placeholder.brand': 'Apple / Dell / ELECOM など',
  'pages.fixedAssets.placeholder.os': 'Windows 11 / macOS など',
  'pages.fixedAssets.placeholder.location': '所在地を選択',
  'pages.fixedAssets.placeholder.status': 'ステータスを選択',
  'pages.fixedAssets.placeholder.partName': '部品名',
  'pages.fixedAssets.placeholder.userName': '社員候補から選択、または直接入力',
  'pages.fixedAssets.placeholder.currentUser': '空欄は現在使用中',
  'pages.fixedAssets.placeholder.remarks': '購入金額、保証期限、管理メモなどを入力できます。',
  'pages.fixedAssets.validation.assetNameRequired': '資産名を入力してください。',
  'pages.fixedAssets.validation.majorCategoryRequired': '大分類を選択してください。',
  'pages.fixedAssets.validation.purchaseAmountRequired': '購入金額を入力してください。',
  'pages.fixedAssets.validation.purchaseDateRequired': '購入日を選択してください。',
  'pages.fixedAssets.validation.stockInDateRequired': '入庫日を選択してください。',
  'pages.fixedAssets.validation.registrationQuantityRequired': '登録数量を入力してください。',
  'pages.fixedAssets.validation.currentUserSingle': '現在使用中の使用者は1名のみ設定してください。',
  'pages.fixedAssets.validation.locationRequired': '所在地を選択してください。',
  'pages.fixedAssets.confirm.deleteAsset': 'この固定資産を削除しますか？',
  'pages.fixedAssets.confirm.deleteCategory': 'このカテゴリを削除しますか？',
  'pages.fixedAssets.message.loadFailed': '固定資産情報の取得に失敗しました。',
  'pages.fixedAssets.message.detailLoadFailed': '固定資産詳細の取得に失敗しました。',
  'pages.fixedAssets.message.saved': '保存しました。',
  'pages.fixedAssets.message.saveFailed': '固定資産の保存に失敗しました。',
  'pages.fixedAssets.message.deleted': '削除しました。',
  'pages.fixedAssets.message.deleteFailed': '固定資産の削除に失敗しました。',
  'pages.fixedAssets.message.categorySaved': 'カテゴリを保存しました。',
  'pages.fixedAssets.message.categorySaveFailed': 'カテゴリの保存に失敗しました。',
  'pages.fixedAssets.message.categoryDeleted': 'カテゴリを削除しました。',
  'pages.fixedAssets.message.categoryDeleteFailed': 'カテゴリの削除に失敗しました。',
  'pages.fixedAssets.status.running': '稼働中',
  'pages.fixedAssets.status.idle': '未稼働',
  'pages.fixedAssets.status.repairing': '修理中',
  'pages.fixedAssets.status.disposalPlanned': '廃棄予定',
  'pages.fixedAssets.status.disposed': '廃棄済',
  'pages.fixedAssets.location.warehouse': '倉庫',
  'pages.fixedAssets.location.development': '開発部',
  'pages.fixedAssets.location.ec': 'EC部',
  'pages.fixedAssets.location.sales': '営業部',
  'pages.fixedAssets.location.hr': '人事部',
  'pages.fixedAssets.location.generalAffairs': '総務部',
  'pages.fixedAssets.location.accounting': '経理部',
  'pages.fixedAssets.location.other': 'その他',
  'pages.fixedAssets.category.modalTitle': '固定資産カテゴリ管理',
  'pages.fixedAssets.category.addTitle': 'カテゴリ追加',
  'pages.fixedAssets.category.editTitle': 'カテゴリ編集',
  'pages.fixedAssets.category.addMajorTitle': '大分類追加',
  'pages.fixedAssets.category.addSubTitle': '小分類追加',
  'pages.fixedAssets.category.listTitle': 'カテゴリ一覧',
  'pages.fixedAssets.category.addMajorAction': '大分類を追加',
  'pages.fixedAssets.category.addSubAction': '選択中の下に小分類を追加',
  'pages.fixedAssets.category.empty': 'カテゴリがありません。',
  'pages.fixedAssets.category.message.noParentCategory': '先に大分類を追加してください。',
  'pages.fixedAssets.category.column.name': 'カテゴリ名',
  'pages.fixedAssets.category.column.sortOrder': '表示順',
  'pages.fixedAssets.category.column.activeFlag': '状態',
  'pages.fixedAssets.category.parentCategory': '親カテゴリ',
  'pages.fixedAssets.category.parentPlaceholder': '大分類の場合は未選択',
  'pages.fixedAssets.category.parentSelectPlaceholder': '親カテゴリを選択',
  'pages.fixedAssets.category.type': 'カテゴリ種別',
  'pages.fixedAssets.category.majorType': '大分類を追加',
  'pages.fixedAssets.category.subType': '小分類を追加',
  'pages.fixedAssets.category.majorTypeHelp':
    '大分類として追加します。資産番号に使うカテゴリCodeが必要です。',
  'pages.fixedAssets.category.subTypeHelp': '選択した大分類の下に小分類を追加します。',
  'pages.fixedAssets.category.name': 'カテゴリ名',
  'pages.fixedAssets.category.code': 'カテゴリCode',
  'pages.fixedAssets.category.codePlaceholder': '例：IT',
  'pages.fixedAssets.category.sortOrder': '表示順',
  'pages.fixedAssets.category.activeFlag': '有効状態',
  'pages.fixedAssets.category.active': '有効',
  'pages.fixedAssets.category.inactive': '無効',
  'pages.fixedAssets.category.backToCreate': '新規入力へ戻る',
  'pages.fixedAssets.category.validation.parentRequired': '親カテゴリを選択してください。',
  'pages.fixedAssets.category.validation.nameRequired': 'カテゴリ名を入力してください。',
  'pages.fixedAssets.category.validation.codeRequired': 'カテゴリCodeを入力してください。',
  'pages.fixedAssets.category.validation.codePattern': '2～6桁の大文字英数字で入力してください。',

  // ホーム・ゲーミフィケーション
  'pages.home.common.none': '-',
  'pages.home.common.pointSuffix': 'pt',
  'pages.home.common.minutesSuffix': '分',
  'pages.home.notice.title': '社内公示・お知らせ',
  'pages.home.notice.noUnread': '未読なし',
  'pages.home.notice.unreadCount': '未読 {count}件',
  'pages.home.notice.unread': '未読',
  'pages.home.notice.important': '重要',
  'pages.home.notice.viewAll': '一覧へ',
  'pages.home.notice.noPublished': '公開中のお知らせはありません',
  'pages.home.notice.unreadModalTitle': '未読公告',
  'pages.home.notice.noUnreadNotice': '未読公告はありません',
  'pages.home.notice.publishDate': '掲載日: {date}',
  'pages.home.growth.level': 'レベル {level}',
  'pages.home.growth.experience': '経験値 {current}/{next}',
  'pages.home.growth.points': 'ポイント',
  'pages.home.growth.todayUsage': '本日利用',
  'pages.home.growth.usagePoints': '利用ポイント',
  'pages.home.growth.gamePoints': 'ゲームポイント',
  'pages.home.growth.exchangeHint':
    '使用時間とゲーム挑戦でポイントをためて、称号や勲章を交換できます。',
  'pages.home.reward.type.title': '称号',
  'pages.home.reward.type.badge': '勲章',
  'pages.home.reward.type.icon': 'アイコン',
  'pages.home.reward.type.frame': 'フレーム',
  'pages.home.reward.type.reward': '報酬',
  'pages.home.reward.descriptionLabel': '説明:',
  'pages.home.reward.noEquippedBadgeDescription': '装備中の勲章説明はありません。',
  'pages.home.reward.titleNotSet': '称号未設定',
  'pages.home.reward.badgeNotSet': '勲章未設定',
  'pages.home.reward.exchangeSuccess': '報酬を交換しました。',
  'pages.home.reward.exchangeFailed': '報酬交換に失敗しました。',
  'pages.home.reward.equipSuccess': '報酬を装備しました。',
  'pages.home.reward.equipFailed': '報酬装備に失敗しました。',
  'pages.home.reward.exchangeButton': 'ポイント交換',
  'pages.home.reward.exchangeDrawerTitle': 'ポイント交換',
  'pages.home.reward.currentPoints': '現在ポイント',
  'pages.home.reward.empty': '交換できる報酬はありません',
  'pages.home.reward.equipped': '装備中',
  'pages.home.reward.equip': '装備',
  'pages.home.reward.exchange': '交換',
  'pages.home.game.selectionTitle': 'ゲーム選択',
  'pages.home.game.modalFallbackTitle': 'ゲーム',
  'pages.home.game.raiden.title': '雷電ゲーム',
  'pages.home.game.raiden.description': '短時間で集中力を切り替えるシューティングゲームです。',
  'pages.home.game.frogWords.title': '青蛙過河・単語ゲーム',
  'pages.home.game.frogWords.description': '日中IT用語を入力して、青蛙を対岸まで進めます。',
  'pages.home.game.scoreGained': '{game}のスコア送信完了。{points}ポイント獲得しました。',
  'pages.home.game.scoreRecorded': '{game}のスコアを記録しました。本日の追加ポイントはありません。',
  'pages.home.game.scoreSubmitFailed': '{game}のスコア送信に失敗しました。',
  'pages.home.game.leaderboardButton': 'ランキング',
  'pages.home.game.leaderboardTitle': '{game} ランキング',
  'pages.home.game.leaderboardFallbackTitle': 'ランキング',
  'pages.home.game.leaderboardScore': '累計ポイント: {points} / 最高スコア: {bestScore}',
  'pages.home.game.leaderboardNoRank': 'ランク外です。もう少し頑張りましょう。',
  'pages.home.game.leaderboardMyRank': '現在 {rank} 位です。累計ポイント: {points}',
  'pages.home.game.leaderboardEmpty': 'ランキングデータがありません。',
  'pages.home.game.leaderboardLoadFailed': 'ランキングの取得に失敗しました。',
  'pages.home.reward.gitApostle.name': 'Gitの使徒',
  'pages.home.reward.gitApostle.description': 'Git運用に親しんだ人向けの称号です。',
  'pages.home.reward.testPaladin.name': 'テストの聖騎士',
  'pages.home.reward.testPaladin.description': 'テスト品質を守る人向けの勲章です。',
  'pages.home.reward.raidenPilot.name': '雷電パイロット',
  'pages.home.reward.raidenPilot.description': '雷電ゲームに挑戦する人向けのアイコンです。',
  'pages.home.reward.blueFrame.name': 'ブルーフレーム',
  'pages.home.reward.blueFrame.description': 'ホーム画面を少し飾るためのフレームです。',
  'pages.home.reward.bugHunter.name': 'Bug狩人',
  'pages.home.reward.bugHunter.description': '小さな不具合も見逃さない人向けの称号です。',
  'pages.home.reward.sqlSamurai.name': 'SQL侍',
  'pages.home.reward.sqlSamurai.description': '条件と結合を静かに斬る人向けの称号です。',
  'pages.home.reward.diffWizard.name': '差分の魔術師',
  'pages.home.reward.diffWizard.description': 'レビューで差分の意図を読み解く人向けの称号です。',
  'pages.home.reward.morningSprinter.name': '朝活スプリンター',
  'pages.home.reward.morningSprinter.description': '朝から軽快にタスクを進める人向けの称号です。',
  'pages.home.reward.midnightDeployGuardian.name': '深夜デプロイ守護者',
  'pages.home.reward.midnightDeployGuardian.description':
    '夜の静けさの中でリリースを見守る称号です。',
  'pages.home.reward.specTraveler.name': '仕様書の旅人',
  'pages.home.reward.specTraveler.description': '仕様の森を迷わず歩く人向けの称号です。',
  'pages.home.reward.commitCraftsman.name': 'コミット職人',
  'pages.home.reward.commitCraftsman.description':
    'ひとつひとつの変更を丁寧に積む人向けの称号です。',
  'pages.home.reward.bugDetective.name': '不具合探偵',
  'pages.home.reward.bugDetective.description': '現象から原因まで粘り強く追う人向けの称号です。',
  'pages.home.reward.raidenAce.name': '雷電エース',
  'pages.home.reward.raidenAce.description': '雷電ゲームで空を駆ける人向けの称号です。',
  'pages.home.reward.raidenBulletApprentice.name': '弾幕見習い',
  'pages.home.reward.raidenBulletApprentice.description':
    '雷電ゲームで弾幕の洗礼を受け始めた人向けの称号です。',
  'pages.home.reward.raidenRookie.name': '雷電ルーキー',
  'pages.home.reward.raidenRookie.description': 'まずは発進ボタンを押せた勇気を讃える称号です。',
  'pages.home.reward.skyDogfighter.name': '青空ドッグファイター',
  'pages.home.reward.skyDogfighter.description': '青空をくるくる舞いながら戦う人向けの称号です。',
  'pages.home.reward.lowAltitudeDodger.name': '低空回避の名人',
  'pages.home.reward.lowAltitudeDodger.description':
    'なぜか低空飛行で全部かわしたがる人向けの称号です。',
  'pages.home.reward.laserStraightShot.name': 'レーザー一直線',
  'pages.home.reward.laserStraightShot.description':
    '迷わずまっすぐ撃ち抜くタイプの人向けの称号です。',
  'pages.home.reward.cloudSniper.name': '雲間の狙撃手',
  'pages.home.reward.cloudSniper.description': '雲のすき間から正確に狙う人向けの称号です。',
  'pages.home.reward.bossBreath.name': 'ボス前深呼吸',
  'pages.home.reward.bossBreath.description': 'ボス戦の前に一回落ち着ける人向けの称号です。',
  'pages.home.reward.noDamagePrayer.name': 'ノーダメ祈願兵',
  'pages.home.reward.noDamagePrayer.description':
    'ノーダメージを祈りながら突っ込む人向けの称号です。',
  'pages.home.reward.thunderAce.name': '雷鳴エース',
  'pages.home.reward.thunderAce.description': '雷鳴と一緒にスコアを伸ばす人向けの称号です。',
  'pages.home.reward.airspaceCommander.name': '空域制圧隊長',
  'pages.home.reward.airspaceCommander.description':
    '画面いっぱいの敵にも動じない隊長向けの称号です。',
  'pages.home.reward.lilyPadJumper.name': '蓮葉ジャンパー',
  'pages.home.reward.lilyPadJumper.description': '青蛙と一緒に蓮葉をぴょんと進む人向けの称号です。',
  'pages.home.reward.wordHopper.name': '単語ぴょん太',
  'pages.home.reward.wordHopper.description': '単語を見ると反射でぴょんと答える人向けの称号です。',
  'pages.home.reward.jpCnWordFerryman.name': '日中ことば渡し',
  'pages.home.reward.jpCnWordFerryman.description':
    '日本語と中国語の間に橋をかける人向けの称号です。',
  'pages.home.reward.translationRiverGuide.name': '翻訳リバーガイド',
  'pages.home.reward.translationRiverGuide.description':
    '用語の川で迷わず案内できる人向けの称号です。',
  'pages.home.reward.lostParticleRescue.name': '迷子の助詞救助隊',
  'pages.home.reward.lostParticleRescue.description':
    '助詞や語尾をやさしく救助する人向けの称号です。',
  'pages.home.reward.termFishingMaster.name': '用語の釣り名人',
  'pages.home.reward.termFishingMaster.description':
    '記憶の池から正しい用語を釣り上げる人向けの称号です。',
  'pages.home.reward.frogMemoryMaster.name': '青蛙メモリーマスター',
  'pages.home.reward.frogMemoryMaster.description':
    '青蛙より先に単語を覚えてしまう人向けの称号です。',
  'pages.home.reward.bilingualSkipKing.name': '二言語スキップ王',
  'pages.home.reward.bilingualSkipKing.description':
    '二つの言語を軽やかに飛び越える人向けの称号です。',
  'pages.home.reward.wrongAnswerRecovery.name': '誤答リカバリー班',
  'pages.home.reward.wrongAnswerRecovery.description':
    '間違えてもすぐ次の一歩へ進める人向けの称号です。',
  'pages.home.reward.oppositeBankSage.name': '対岸到達の賢者',
  'pages.home.reward.oppositeBankSage.description':
    '最後の蓮葉まで言葉をつないだ人向けの称号です。',
  'pages.home.reward.quietImprover.name': '静かな改善者',
  'pages.home.reward.quietImprover.description': '目立たない改善を積み重ねる人向けの称号です。',
  'pages.home.reward.qualityGuardianBadge.name': '品質守護バッジ',
  'pages.home.reward.qualityGuardianBadge.description': '品質を大切にする姿勢を示す勲章です。',
  'pages.home.reward.learningFinisherMedal.name': '学習完走メダル',
  'pages.home.reward.learningFinisherMedal.description': '学び切る力を讃える勲章です。',
  'pages.home.reward.monthEndAttendanceMaster.name': '月末勤怠マスター',
  'pages.home.reward.monthEndAttendanceMaster.description': '月末処理を忘れない人向けの勲章です。',
  'pages.home.reward.blueLightning.name': '青い稲妻',
  'pages.home.reward.blueLightning.description': 'ホームを少しシャープに見せるアイコンです。',
  'pages.home.reward.coffeeRefueler.name': 'コーヒー補給機',
  'pages.home.reward.coffeeRefueler.description': '集中時間のお供にしたいアイコンです。',
  'pages.home.reward.keyboardNinja.name': 'キーボード忍者',
  'pages.home.reward.keyboardNinja.description': '素早い入力を楽しむ人向けのアイコンです。',
  'pages.home.reward.sakuraFrame.name': 'サクラフレーム',
  'pages.home.reward.sakuraFrame.description': 'やわらかい印象のプロフィールフレームです。',
  'pages.home.reward.nightShiftFrame.name': 'ナイトシフトフレーム',
  'pages.home.reward.nightShiftFrame.description': '夜の集中作業をイメージしたフレームです。',
  'pages.home.reward.goldLine.name': 'ゴールドライン',
  'pages.home.reward.goldLine.description': '少しだけ特別感を出すゴールド系フレームです。',
  'pages.hrDocument.title': '書類申請',
  'pages.hrDocument.management.title': '書類申請管理',
  'pages.hrDocument.management.listTitle': '申請管理一覧',
  'pages.hrDocument.list.title': '申請一覧',
  'pages.hrDocument.detail.title': '書類申請詳細',
  'pages.hrDocument.status.0': '下書き',
  'pages.hrDocument.status.1': '承認待ち',
  'pages.hrDocument.status.2': '差戻し',
  'pages.hrDocument.status.3': '作成中',
  'pages.hrDocument.status.4': '受取待ち',
  'pages.hrDocument.status.5': '完了',
  'pages.hrDocument.status.6': '取消',
  'pages.hrDocument.delivery.download': 'システムダウンロード',
  'pages.hrDocument.delivery.pickup': '窓口受取',
  'pages.hrDocument.field.requestNo': '申請番号',
  'pages.hrDocument.field.status': 'ステータス',
  'pages.hrDocument.field.applicant': '申請者',
  'pages.hrDocument.field.department': '所属部門',
  'pages.hrDocument.field.documentType': '書類種類',
  'pages.hrDocument.field.quantity': '部数',
  'pages.hrDocument.field.reason': '用途・申請理由',
  'pages.hrDocument.field.destination': '提出先',
  'pages.hrDocument.field.desiredDate': '希望交付日',
  'pages.hrDocument.field.deliveryMethod': '交付方法',
  'pages.hrDocument.field.notes': '補足事項',
  'pages.hrDocument.field.returnReason': '差戻し理由',
  'pages.hrDocument.field.cancelReason': '取消理由',
  'pages.hrDocument.field.actions': '操作',
  'pages.hrDocument.action.create': '新規申請',
  'pages.hrDocument.action.edit': '編集',
  'pages.hrDocument.action.detail': '詳細',
  'pages.hrDocument.action.submit': '提出',
  'pages.hrDocument.action.cancel': '取消',
  'pages.hrDocument.action.delete': '削除',
  'pages.hrDocument.action.download': 'ダウンロード',
  'pages.hrDocument.action.approve': '承認',
  'pages.hrDocument.action.return': '差戻し',
  'pages.hrDocument.action.ready': '準備完了',
  'pages.hrDocument.action.complete': '交付完了',
  'pages.hrDocument.action.upload': 'PDF登録',
  'pages.hrDocument.action.confirm': '確認',
  'pages.hrDocument.action.back': '戻る',
  'pages.hrDocument.confirm.submit': 'この申請を提出しますか？',
  'pages.hrDocument.confirm.cancel': 'この申請を取消しますか？',
  'pages.hrDocument.confirm.delete': 'この申請を物理削除しますか？',
  'pages.hrDocument.confirm.approve': 'この申請を承認しますか？',
  'pages.hrDocument.confirm.ready': '交付準備を完了しますか？',
  'pages.hrDocument.confirm.complete': '書類の交付を完了しますか？',
  'pages.hrDocument.confirm.deleteFile': 'このPDFを削除しますか？',
  'pages.hrDocument.confirm.deleteType': 'この書類種類を削除しますか？',
  'pages.hrDocument.filter.status': 'ステータス',
  'pages.hrDocument.filter.all': 'すべて',
  'pages.hrDocument.filter.keyword': '申請番号・書類種類・理由で検索',
  'pages.hrDocument.filter.managementKeyword': '申請番号・社員名・理由で検索',
  'pages.hrDocument.form.createTitle': '書類申請を作成',
  'pages.hrDocument.form.editTitle': '書類申請を編集',
  'pages.hrDocument.files.title': '交付ファイル',
  'pages.hrDocument.files.empty': '交付ファイルはありません',
  'pages.hrDocument.history.title': '処理履歴',
  'pages.hrDocument.return.title': '書類申請を差戻し',
  'pages.hrDocument.cancel.title': '書類申請を取消',
  'pages.hrDocument.type.manage': '書類種類管理',
  'pages.hrDocument.type.create': '書類種類を追加',
  'pages.hrDocument.type.edit': '書類種類を編集',
  'pages.hrDocument.type.code': '種類コード',
  'pages.hrDocument.type.name': '種類名',
  'pages.hrDocument.type.description': '説明',
  'pages.hrDocument.type.order': '表示順',
  'pages.hrDocument.type.active': '有効状態',
  'pages.hrDocument.type.enabled': '有効',
  'pages.hrDocument.type.disabled': '無効',
  'pages.hrDocument.msg.loadFailed': '書類申請の読込に失敗しました。',
  'pages.hrDocument.msg.detailFailed': '申請詳細の読込に失敗しました。',
  'pages.hrDocument.msg.actionFailed': '処理に失敗しました。',
  'pages.hrDocument.msg.downloadFailed': 'ファイルのダウンロードに失敗しました。',
  'pages.hrDocument.msg.saveSuccess': '書類申請を保存しました。',
  'pages.hrDocument.msg.saveFailed': '保存に失敗しました。',
  'pages.hrDocument.msg.submitSuccess': '書類申請を提出しました。',
  'pages.hrDocument.msg.cancelSuccess': '書類申請を取消しました。',
  'pages.hrDocument.msg.deleteSuccess': '書類申請を削除しました。',
  'pages.hrDocument.msg.approveSuccess': '書類申請を承認しました。',
  'pages.hrDocument.msg.returnSuccess': '書類申請を差戻しました。',
  'pages.hrDocument.msg.readySuccess': '交付準備を完了しました。',
  'pages.hrDocument.msg.completeSuccess': '書類の交付を完了しました。',
  'pages.hrDocument.msg.uploadSuccess': 'PDFを登録しました。',
  'pages.hrDocument.msg.uploadFailed': 'PDFの登録に失敗しました。',
  'pages.hrDocument.msg.fileDeleteSuccess': 'PDFを削除しました。',
  'pages.hrDocument.msg.typeSaveSuccess': '書類種類を保存しました。',
  'pages.hrDocument.msg.typeDeleteSuccess': '書類種類を削除しました。',
  'pages.hrDocument.action.save': '保存',
  'pages.hrDocument.action.register': '登録',
  'pages.hrDocument.action.preview': 'PDFプレビュー',
  'pages.hrDocument.action.generate': 'PDF生成',
  'pages.hrDocument.action.generateDeliver': 'PDF生成・交付',
  'pages.hrDocument.action.redeliver': '再交付',
  'pages.hrDocument.confirm.redeliver': 'ダウンロード期限を7日間延長して再交付しますか？',
  'pages.hrDocument.confirm.deleteStamp': 'この電子印を物理削除しますか？',
  'pages.hrDocument.type.deliveryMethods': '利用可能な交付方法',
  'pages.hrDocument.type.allowDownload': 'オンラインダウンロード',
  'pages.hrDocument.type.allowPickup': '窓口受取',
  'pages.hrDocument.template.edit': 'テンプレート',
  'pages.hrDocument.template.title': '{type} テンプレート',
  'pages.hrDocument.template.name': 'テンプレート名',
  'pages.hrDocument.template.variables': '自動差込変数（クリックで追加）',
  'pages.hrDocument.template.body': 'テンプレート本文',
  'pages.hrDocument.template.customFields': '生成時の追加入力項目',
  'pages.hrDocument.template.fieldLabel': '項目名',
  'pages.hrDocument.template.required': '必須',
  'pages.hrDocument.template.addField': '入力項目を追加',
  'pages.hrDocument.stamp.manage': '電子印管理',
  'pages.hrDocument.stamp.name': '電子印名',
  'pages.hrDocument.stamp.fileName': '登録ファイル',
  'pages.hrDocument.stamp.selectPng': 'PNGを選択',
  'pages.hrDocument.generate.title': '書類PDF生成',
  'pages.hrDocument.generate.stamp': '電子印',
  'pages.hrDocument.generate.noStamp': '電子印なし',
  'pages.hrDocument.download.notice':
    '交付日から7日以内は繰り返しダウンロードできます。期限を過ぎた場合は人事部へ再交付を依頼してください。',
  'pages.hrDocument.download.expired':
    'ダウンロード期限を過ぎています。人事部へ再交付を依頼してください。',
  'pages.hrDocument.download.expiresAt': 'ダウンロード期限',
  'pages.hrDocument.download.expiredShort': '期限切れ',
  'pages.hrDocument.download.countdown': '残り {days}日 {hours}時間',
  'pages.hrDocument.msg.templateLoadFailed': 'テンプレートの読込に失敗しました。',
  'pages.hrDocument.msg.templateSaveSuccess': 'テンプレートを保存しました。',
  'pages.hrDocument.msg.templateSaveFailed': 'テンプレートの保存に失敗しました。',
  'pages.hrDocument.msg.stampLoadFailed': '電子印の読込に失敗しました。',
  'pages.hrDocument.msg.stampSaveFailed': '電子印の登録に失敗しました。',
  'pages.hrDocument.msg.generateLoadFailed': 'PDF生成情報の読込に失敗しました。',
  'pages.hrDocument.msg.previewFailed': 'PDFプレビューの生成に失敗しました。',
  'pages.hrDocument.msg.generateSuccess': 'PDFを生成して交付しました。',
  'pages.hrDocument.msg.generateFailed': 'PDFの生成・交付に失敗しました。',
  'pages.hrDocument.msg.redeliverSuccess': '書類を再交付しました。',
  'pages.invoiceList.taxCategory': '税区分',
  'pages.invoiceList.taxCategory.taxable': '課税',
  'pages.invoiceList.taxCategory.nonTaxable': '非課税',
  'pages.invoiceList.amount.subtotal': '小計',
  'pages.invoiceList.amount.taxableSubtotal': '課税対象額',
  'pages.invoiceList.amount.nonTaxableSubtotal': '非課税額',
  'pages.invoiceList.amount.tax': '消費税 10%',
  'pages.invoiceList.amount.total': '合計金額',
  'pages.invoiceList.attendance.totalHours': '当月稼働時間',
  'pages.invoiceList.attendance.status': '勤怠状態',
  'pages.invoiceList.attendance.status.unsubmitted': '未提出',
  'pages.invoiceList.attendance.status.pending': '承認待ち',
  'pages.invoiceList.attendance.status.approved': '承認済',
  'pages.invoiceList.attendance.export': '勤怠出力',
  'pages.invoiceList.attendance.export.excel': 'Excel出力',
  'pages.invoiceList.attendance.export.pdf': 'PDF出力',
  'pages.invoiceList.attendance.export.noTargets': '勤怠出力対象者がいません。',
  'pages.accounting.dashboard.title': '経理ダッシュボード',
  'pages.accounting.dashboard.subtitle':
    '請求収入から契約社員・正社員の人件費総コストを差し引いた概算値です。',
  'pages.accounting.dashboard.monthSuffix': '月',
  'pages.accounting.dashboard.mode.forecast': '見込',
  'pages.accounting.dashboard.tax.excluded': '税抜',
  'pages.accounting.dashboard.tax.included': '税込',
  'pages.accounting.dashboard.metric.revenue': '請求収入',
  'pages.accounting.dashboard.metric.personnelCost': '人件費総コスト',
  'pages.accounting.dashboard.metric.profit': '人件費控除後概算利益',
  'pages.accounting.dashboard.section.monthly': '{month}月度',
  'pages.accounting.dashboard.section.annual': '{year}年 合計',
  'pages.accounting.dashboard.note.selectedMonth': '選択月',
  'pages.accounting.dashboard.note.salaryFormula': '基本給 + 特別手当 + 会社負担見込額',
  'pages.accounting.dashboard.note.annual': '1月から12月の合計',
  'pages.accounting.dashboard.note.margin': '利益率 {margin}',
  'pages.accounting.dashboard.table.title': '12か月明細',
  'pages.accounting.dashboard.table.month': '月度',
  'pages.accounting.dashboard.table.baseSalary': '基本給',
  'pages.accounting.dashboard.table.specialAllowance': '特別手当',
  'pages.accounting.dashboard.table.employerBurden': '会社負担見込額',
  'pages.accounting.dashboard.table.margin': '利益率',
  'pages.accounting.dashboard.table.warningCount': '要確認人数',
  'pages.accounting.dashboard.status.review': '要確認',
  'pages.accounting.dashboard.warning.title': '計算に確認が必要な月があります',
  'pages.accounting.dashboard.warning.description':
    '基本給・生年月日・料率の不足、退社日未登録、在籍期間外の精算がある月は、コスト合計と概算利益を要確認として表示しています。現在停用でも過去の在籍月は計算に含みます。',
  'pages.accounting.dashboard.message.loadFailed': '経理ダッシュボードの取得に失敗しました。',
  'pages.attendanceInput.submitConfirm.title': '勤怠提出の確認（{year}年{month}月）',
  'pages.attendanceInput.submitConfirm.message':
    '当月の勤怠情報をすべて入力してから提出してください。入力漏れがないか確認しましたか？',
  'pages.attendanceInput.submitConfirm.editLock': '提出後は編集できなくなります。',
  'pages.attendanceInput.submitConfirm.ok': '確認して提出',
  'pages.attendanceInput.submitConfirm.cancel': '戻って確認',
  'pages.development.learnManagement.progress.evaluation.title': '評価',
  'pages.development.learnManagement.progress.evaluation.empty': '未記入',
  'pages.development.learnManagement.progress.evaluation.edit': '評価を編集',
  'pages.development.learnManagement.progress.evaluation.save': '保存',
  'pages.development.learnManagement.progress.evaluation.cancel': 'キャンセル',
  'pages.development.learnManagement.progress.evaluation.placeholder':
    '評価を入力してください（100文字以内）',
  'pages.development.learnManagement.progress.evaluation.saved': '評価を保存しました。',
  'pages.development.learnManagement.progress.evaluation.saveFailed':
    '評価を保存できませんでした。入力内容を確認して再試行してください。',
  'pages.development.learnManagement.progress.evaluation.tooLong':
    '評価は100文字以内で入力してください。既存の内容は自動で切り詰めません。',
};
